import { Component, OnInit } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
//Ventana Modal
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//Formularios
import { NgForm } from '@angular/forms';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Alertas
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
//Acordeon
import { AccordionModule } from "ng2-accordion";
//Limpiar urls de los archivos
import { Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
//Servicios
import { ContactosService } from '../../../servicios/Terceros/contactos.service';
import { ConfigService } from '../../../servicios/config/config.service';
import { ValidService } from '../../../servicios/valid.service';
import { KeyService } from '../../../servicios/key.service';
import { PqrService } from '../../../servicios/pqr/pqr.service';
import { TercerosService } from '../../../servicios/terceros/terceros.service';
import { TiposervicioService } from '../../../servicios/pqr/tiposervicio.service';
import { PrioridadService } from '../../../servicios/pqr/prioridad.service';
import { EquipoTerceroService } from '../../../servicios/equipos/equipo-tercero.service';
import { EstadopqrService } from '../../../servicios/pqr/estadopqr.service';
import { TratamientopqrService } from '../../../servicios/pqr/tratamientopqr.service';
import { TecnicoasignadopqrService } from '../../../servicios/pqr/tecnicoasignadopqr.service';
import { NotadetallepqrService } from '../../../servicios/pqr/notadetallepqr.service';
import { toBase64String } from '@angular/compiler/src/output/source_map';
import { arch } from 'os';
import { UsuariosService } from '../../../servicios/usuarios/usuarios.service';
import { and } from '@angular/router/src/utils/collection';
import { PerfilesService } from '../../../servicios/perfiles/perfiles.service';
import { RastreoService } from '../../../servicios/rastreo/rastreo.service';
import { TipopqrService } from '../../../servicios/pqr/tipopqr.service';
import { EventosJqueryService } from '../../../servicios/eventos-jquery/eventos-jquery.service';
//Datalist
import { SucursalService } from '../../../servicios/Terceros/sucursal.service';
import { AgendamientoAppService } from '../../../servicios/agendamiento-app/agendamiento-app.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { filter } from 'rxjs/operator/filter';
//Componentes
import { AgendamientoAppComponent } from './../../agendamiento-app/agendamiento-app.component';
import { decode } from '@angular/router/src/url_tree';
import { Session } from 'protractor';

import * as JSZip from 'jszip';
import { ContentType } from '@angular/http/src/enums';

import { HostListener } from '@angular/core';

//configuración del idioma de los datapicker
import { add, defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { SlicePipe } from '@angular/common';
import { count } from 'rxjs/operator/count';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Component({
  selector: 'app-tratamiento-pqr',
  templateUrl: './tratamiento-pqr.component.html',
  styleUrls: ['./tratamiento-pqr.component.css'],
  providers: [
    TipopqrService,
    RastreoService,
    TecnicoasignadopqrService,
    AgendamientoAppService,
    ContactosService
  ]
})
export class TratamientoPqrComponent implements OnInit {
  arrayAsignacion = new Array();
  hidecontacto = false;
  servicio: any;
  contactos = new Array();

  language = {
    lengthMenu        : "Mostrar _MENU_ registros por página.",
    zeroRecords       : "No se ha encontrado ningún registro.",
    info              : "Mostrando _START_ a _END_ de _TOTAL_ entradas.",
    infoEmpty         : "Registros no disponibles.",
    search            : "",
    searchPlaceholder : "Buscar",
    loadingRecords    : "Cargando...",
    processing        : "Procesando...",
    paginate          : {
      first     : "Primero",
      last      : "Último",
      next      : "Siguiente",
      previous  : "Anterior"
    },
    infoFiltered      : "(_MAX_ Registros filtrados en total)"
  };

  columnas = {
    columns: [1, 2]
  };


  buttons = [
    { extend: 'excel', className: 'excelButton', text: 'Excel', exportOptions: this.columnas },
    { extend: 'copy', className: 'excelButton', text: 'Copiar', exportOptions: this.columnas },
    { extend: 'csv', className: 'excelButton', text: 'CSV', exportOptions: this.columnas },
    { extend: 'pdf', className: 'pdfButton', tex: 'PDF', exportOptions: this.columnas },
    { extend: 'print', className: 'printButton', text: 'Imprimir', exportOptions: this.columnas }
  ];


  tecnicosLista               : any[];
  saldoconsumo                : any;
  coordinadorArray            : any[];
  listTecnicoporCordinador    = new Array();//listado de tecnicos por coordinador
  listcoordinadores_aux       = new Array();//listado de otros coordinadores
  TecnicoList                 = new Array();
  usuarioCliente              : any;   //valida si el usuario es cliente
  tecnicoApp                  : any;  // almacena cedula  para modal app en la web
  nombretecnicoApp            : any;  // almacena nombre y cedula para modal app en la web
  dataAutorizo                : any;
  eventoclic                  : any = 0;
  listpermisos                : any;
  mostrarpreloaderpri         : any = 1;
  estadotablacerrarActividad  : any;
  PATH                        : any;
  modalRef                    : BsModalRef; //Ventana modal
  formAcciones                : FormGroup;
  dependencias                : any;
  tecnicos                    : any;
  tiposervicios               : any;
  tipopqr                     : any;
  tiposprioridad              : any;
  estadospqr                  : any[];
  transicionestado            : any[];
  estadosservicio             : any[];
  estadospqrCierre            : any[];
  cumplida                    : boolean = false;
  validaVersion               : boolean = false;
  dtpqrArray                  : any[]; //listado de detalles de una pqr
  id_detallepqr               : any; //Variable que maneja el id del detalle de la PQR
  estado_actualizado          : any; //Variable que maneja un valor 1 / 0 para el detalle de la PQR
  campos                      = [{ 'id': 'campo1' }]; //Arreglo inicial para agregar campos dinamicos
  camposAgenda                = [{ 'id': 'campo1' }]; //Arreglo inicial para agregar campos dinamicos
  cantidadcampos              : any = 1;            //Guardar la cantidad de campos agregados
  cantidadcamposasignados     : any; //Variable para almacenar la cantidad de campos de los tecnicos asignados
  tapqrArray                  : any[]; //listado de tecnicos asignados
  coordinadores               : any; //Listado de coordinadores
  listasignarcoordinadores    : any; //Listado de coordinadores a asignar
  coordinadores_aux           : any; //Listado de otros coordinadores
  formNotas                   : FormGroup;
  notaArray                   : any[]; //listado de notas del detalle de una pqr
  archivonotaArray            : any[]; //listado de archivos de las notas del detalle de una pqr
  notaArrayHistorial          : any[]; //listado de notas historial del detalle de una pqr
  archivonotaArrayHistorial   : any[]; //listado de archivos de las notas historial del detalle de una pqr
  nombre_estadopqr            : any; //Variable que maneja el nombre del estado de la PQR
  nombre_colorhexadecimal     : any; //Variable que maneja el color de la PQR
  tecnicoscoordinadores       : any; //Listado de tecnicos por coordinador
  tecnicoscoordinadores_aux   : any; //Listado auxiliar de tecnicos por coordinador
  tecnicosotroscoordinadores  : any; //Listado de tecnicos  de otros coordinadores
  listTecnicosDetallePqr      : any; //Listado de tecnicos segun detallepqrid
  mostrarDatos                : boolean = false;
  noMostrarDatos              : boolean = false;
  msjtexto                    = 'No hay tecnicos asignados.'; //Mensaje de texto que se muestra si no hay tecnicos asignados
  mostrarasignar              : boolean = false;
  urlarchivo                  : any;
  sanitizedURL                : any;
  disabled                    : boolean = false;
  disabledReabrir             : boolean = false;

  validaIncCierre             : any
  mostrarBotonRefresh         : boolean = false;
  tecnicoidAsignado           : any;
  consecutivoTecnicoAsignadoPqr: any;
  accion                      : any = '';
  detallepqriid               : any;

  mostrarBotonRefreshCierreActividad: boolean = false;
  disabledActividad: boolean = false;
  bloquearfinalizar: boolean = false;
  tecnicosCierreActividades: any;
  tecnicosCierre = new Array();
  tecnicosCierre_aux = new Array();
  imageSrc: string = '';
  urls_archivos = [];
  tipo_archivos = [];
  listArchivos = [];
  listproveedir = [];
  listaArchivos = new Array();
  listaTipoActividad = new Array();
  arrayAgregarTecnicos = new Array();
  arrayAgregarTecnicosAgenda = new Array();
  activarAdicionarCampos: boolean = true;
  cantidadcamposAgenda: any = 1;            //Guardar la cantidad de campos agregados
  tecnicoagendamientoArray_aux: any[];
  tecnicoArray: any[];

  incconelineaconta: any;
  incconelineainven: any;
  servidorbdconta: any;
  basedatosconta: any;
  usuarioconta: any;
  claveconta: any;
  servidorbdinven: any;
  basedatosinven: any;
  usuarioinven: any;
  claveinven: any;
  procesorequisicion: any;
  clonarinc: any;
  tipoinventario: any;
  pqrid: number;
  cierre: number;
  itemequipoid: number;
  extensionArchivo: string;

  //Objeto para PQR
  registropqr = {
    pqrid: '',
    nombresubcomponente: '',
    created_at: '',
    fechalimite: '',
    colorfechalimite: '',
    color: '',
    horalimite: '',
    fechapqr: '',
    ticket: '',
    nombremediosoporte: '',
    nombrecliente: '',
    terceroid: '',
    direccion: '',
    telefono: '',
    tipopqrid: '',
    tiposervicioid: '',
    estadopqrid: '',
    asunto: '',
    descripcion: '',
    prioridadid: '',
    dependenciaid: '',
    coordinadorid: '',
    sucursal: '',
    sucursalid: '',
    nombresucursal: '',
    direccionsucursal: '',
    telefonosucursal: '',
    visibilidad: '',
    nversion: '',
    tecnicoid: '',
    cierre: 0,
    equipoterceroid: '',
    equipotercero: '',
    tipomantenimientoid: '',
    actividadid: '',
    reasignarcoordinadorid: '',
    otrocoordinadorid: '',
    originadopor: '',
    itemcomponenteid: '',
    serial: '',
    operacionid: '',
    operacion: '',
    itemequipoid: '',
    cotizacion: '',
    fichatecnica: '',
    equipoid: '',
    tiempo: '',
    valorfrecuencia: '',
    esproveedor: '',
    costo: '',
    presupuestoplaneado: '',
    versionactual: '',
    versionid: '',
    arrayversiones: '',
    contactoid: '',
    nombrcomer: '',
    cambiaversion: '',
    pqrarelacionar: '',
    archivo: '',
    codigointerno: '',
    componenteid: '',
    componenteequipoid: '',
    listaschequeo: null,
    listaschequeorespuesta: null,
    fotos: []
  }

  //Objeto para Detalle PQR
  detallepqr = {
    pqrid: '',
    fecha: '',
    estadopqr: '',
    colorhexadecimal: '',
    detalle: '',
    files: '',
    estadopqrid: '',
    archivosanexos: '',
    cumplido: '',
    detallepqr: ''
  }

  //Horas
  horas = [
    "00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30",
    "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
    "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30"
  ];

  //Obtener el usuario
  getUsuarioId: any = localStorage.getItem('usuarioid');
  getPerfilUsuario: any = localStorage.getItem('perfil');
  idperfil: any = localStorage.getItem('idperfil'); // almacena el el perfil del usuario para vaklidar si es de tipo C es cliente
  perfilUsuario = this.getPerfilUsuario;
  tipousuario: any = localStorage.getItem('tipousuario');
  getCedulaUsuario: any = localStorage.getItem('cedulaUsuario');


  /* *********************************************************** */

  formNuevaprogramacion: FormGroup;
  sindatos = '';
  listCoordinador: any[]; //Listado de coordinadores
  mostrarCampo: boolean = false; //muestra u oculta un campo
  mostrarBotonHabilitarModificar: boolean = false; //muestra u oculta boton
  disabledcampo: boolean = true; //habilita o deshabilita un campo
  disabledBtnGuardar: boolean = true; //habilita o deshabilita el boton guardar
  disabledCierreCactividad: boolean = false; //habilita o deshabilita el boton guardar cierre actividades
  clientes: any; //listado de clientes
  mensajeError: any;
  mostrarpreloader: boolean = false;
  mostrarcalendar: boolean = true;
  listTecnico: any[]; //Listado de tecnicos
  listTecnico_aux = new Array();

  listTecnicoAgenda_aux = new Array();

  mostrarBotonesAgenda: boolean = false;
  tecnicoagendamientoArray = new Array();
  tiposerviciosagendamiento: any;
  listactividadesFamilia = new Array();
  totalActividadesFamilia = new Array();
  estadoactividadincidencia: any; // validad controla actividades desde la incidencia
  fichatecnica: any; // validad controla fichas tecnicas
  agendartodotiposervicio: any; // validad controla si desea agendar todos los tipo actividades
  muestraModalListaChequeo: boolean = false;
  reloadTablaListaChequeo: boolean = false;
  imagenesEvidenciasFotograficas = [];
  activarSlideIndex     = 0; //Indice de activacion del slider
  descargarVerArchivo: boolean = false;

  //Formulario Nueva Programacion
  nuevaprogramacion = {
    agendamientoid: '', tipomantenimientoid: '',
    fecha: '', horainicial: '',
    horafinal: '', ticket: '',
    pqrid: '', estado: '',
    terceroid: '', sucursalid: '',
    equipoterceroid: '', asunto: '',
    tiposervicioid: '', estadopqrid: '',
    tipopqrid: '', coordinadorid: '',
    descripcion: '', fechaagendaid: '',
    detallepqrid: '', alertapqrid: '',
    fechafinal: '', prioridadid: '',
    colorhexadecimal: '', tipoactividadid: '',
    serial: '', cierre: '',
    validadoperaciontiempo: '', operacionid: '',
    operacion: '', dependenciaid: '',
    otrocoordinadorid: '', valorfrecuencia: '',
    tiempo: '', itemcomponenteid: '',
    esproveedor: '', presupuestoplaneado: '',
    tecnicoagendamiento: this.tecnicoagendamientoArray
  }

  //Horas
  hora = [
    "00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30",
    "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
    "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30"
  ];

  //DATALIST FILTROS DE CREACION
  statesClienteCrear = new Array();
  statesSucursalCrear = new Array();
  statesEquipoCrear = new Array();
  statesComponentes = new Array();
  statesSubComponentes = new Array();
  statesOperacion = new Array();
  selectedOptionCliente: any;
  selectedOptionComponente: any;
  selectedOptionSucursal: any;
  selectedOptionEquipo: any;
  dtTblInsumos: any;
  dtTblrelacionheadpqr: any;
  noResultCliente = false;
  noResultSucursal = false;
  noResultEquipo = false;
  noResultOperacion = false;
  noResultComponente = false;
  noResultSubComponente = false;
  noResultcosto = false;
  /* *********************************************************** */

  //Constructor
  constructor(
    private _config: ConfigService,
    private _valid: ValidService,
    private _key: KeyService,
    private route: ActivatedRoute,
    private router: Router,
    private http: Http,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private _pqr: PqrService,
    private _tercero: TercerosService,
    private _equipoTercero: EquipoTerceroService,
    private _tiposervicio: TiposervicioService,
    private _estadopqr: EstadopqrService,
    private _tratamientopqr: TratamientopqrService,
    private _prioridad: PrioridadService,
    private _tecnicoasignadopqr: TecnicoasignadopqrService,
    private _notadetallepqr: NotadetallepqrService,
    private domSanitizer: DomSanitizer,
    private _usuarios: UsuariosService,
    private _sucursal: SucursalService,
    private _agendamiento: AgendamientoAppService,
    private _perfiles: PerfilesService,
    private _rastreo: RastreoService,
    private _tipopqr: TipopqrService,
    private _evtjq: EventosJqueryService,
    private _contacto: ContactosService,
    private esLocale: BsLocaleService
  ) { }


  ngOnInit() {
    var self = this;
    this.obtenerCoordinadoresagenda();
    this.registropqr.colorfechalimite = '#fff';
    //Bloque que permite controlar los clics para llos modal de las horas
    document.addEventListener("click", function (e) {
      var hoursini, minutesini, secondsini;
      var datehoraini = new Date($('#horainicial').val());
      hoursini = ("0" + datehoraini.getHours()).slice(-2);
      minutesini = ("0" + datehoraini.getMinutes()).slice(-2);
      secondsini = ("0" + datehoraini.getSeconds()).slice(-2);
      var fulltimeini = [hoursini, minutesini, secondsini].join(":");

      var hoursfin, minutesfin, secondsfin;
      var datehorafin = new Date($('#horafinal').val());
      hoursfin = ("0" + datehorafin.getHours()).slice(-2);
      minutesfin = ("0" + datehorafin.getMinutes()).slice(-2);
      secondsfin = ("0" + datehorafin.getSeconds()).slice(-2);
      var fulltimefin = [hoursfin, minutesfin, secondsfin].join(":");
      if (fulltimeini != 'aN:aN:aN') {
        $('#horainicial').val(fulltimeini);
      }
      if (fulltimefin != 'aN:aN:aN') {
        $('#horafinal').val(fulltimefin);
      }
    }, false);

    this.esLocale.use('es');

    //Escucha los eventos al presionar la tecla Enter
    this._evtjq.eventoTeclaEnter();
    let id_pqr = this.route.snapshot.paramMap.get('id');
    this.getPermisos(id_pqr);
    this.obtenerTipoServicio();
    this.obtenerTipoprioridad();
    this.obtenerEstadopqr();
    this.obtenerTipoPqr();
    this.paramCampos();
    this.getdependencia();
    this.createForm();
    this.createFormNotas();
    this.formnuevaprogramacion();
    this.obtenerTerceros('C');
    this.obtenerTercerosProveedor();
    this.habilitarCampoTipoActividad(id_pqr);
    this.adicionarCampos();
    this.adicionarCamposAgenda();

    //RASTREO
    let opcionEnviar = 'Ingreso Tratamiento de la Incidencia ' + id_pqr;
    this._rastreo.setRastreo(opcionEnviar, 'Tratamiento de la Incidencia').subscribe((resp) => {
    });

    if (this.idperfil == "C" || this.idperfil == "S" || this.idperfil == "CC") {
      this.usuarioCliente = 1;
    } else {
      this.usuarioCliente = 0;
    }


    $(document).off('change', '.costo').on('change', '.costo', function () {
      let fecha = self.registropqr.fechapqr;
      let index = $(this).attr('data-index');
      let saldoconsumo = 0;
      let date = new Date(fecha);
      let anio = date.getFullYear();
      self._tratamientopqr.validarcostoProveedor($(this).attr('data-tecnicoid'), anio, self.registropqr.pqrid).subscribe((resp) => {
        if (resp.data.length > 0) {
          var sumacosto = parseInt($(this).val()) + (resp.data[0].consumo ? parseInt(resp.data[0].consumo) : 0);
          if (sumacosto > resp.data[0].costoestimado) {
            $(this).val('');
            saldoconsumo = resp.data[0].consumo ? resp.data[0].costoestimado - parseInt(resp.data[0].consumo) : 0;
            if ($(this).attr('data-tipo') == 'antes') {
              $('#alertaantes_' + index).removeClass('hide');
              $('#alertaantes_' + index).html('Supera el costo Permitido, Saldo Actual :' + saldoconsumo);
            } else {
              $('#alertanuevo_' + index).html('Supera el costo Permitido, Saldo Actual :' + saldoconsumo);
              $('#alertanuevo_' + index).removeClass('hide');
            }
          } else {
            self.noResultcosto = false;
            if ($(this).attr('data-tipo') == 'antes') {
              $('#alertaantes_' + index).addClass('hide');
              $('#alertaantes_' + index).html('');
            } else {
              $('#alertanuevo_' + index).addClass('hide');
              $('#alertanuevo_' + index).html('');
            }
          }
        } else {
          $(this).val('');
          saldoconsumo = 0;
        }
      });
    });


    $('#itemcomponenteid').off('change',).on('change', function (e) {
      e.preventDefault();
      $(this).attr('equipoid');
      let equipoid = $(this).find(':selected').attr('data-equipoid');
      let componenteid = $(this).find(':selected').attr('data-componenteid');
      let fichatecnicaservicioid = $(this).find(':selected').attr('data-fichatecnicaservicioid');
      self.statesSubComponentes = [];
      self.GetSubComponentesEquipo(equipoid, componenteid, fichatecnicaservicioid);
    });

    $('#selectPrioridadidTratamiento').focus();
  }

  /**
   * Permite obtener el listado de terceros
   * CESAR ARIAS-2020-08-21
   */
  obtenerTercerosProveedor() {
    //Si es cliente
    this._tercero.getListTerceros('Proveedor').subscribe((resp) => {
      this.listproveedir = [];
      for (let i in resp.data) {
        if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
          this.listproveedir.push(resp.data[i]);
        };
      }
    });
  }

  /**
* Permite cerrar un modal
* CAAA-2019-01-16
*/
  cerrarmodal() {
    $('.modal:visible:last, .modal-backdrop').fadeOut();
    $('.modal:visible:last').remove();
    $('body').removeClass('modal-open');
  }// .cerrarmodal()

  /**
  * Obtener parametros de la tabla montaje para viualizar campos
  * JMM-2018-10-04
  */
  paramCampos() {
    let self = this;
    //Obtener parametros
    this._pqr.paramCampos().subscribe((resp) => {
      if (resp.data) {
        this.estadoactividadincidencia = resp.data.actividadincidencia;
        this.fichatecnica = resp.data.fichatecnica;
        this.servicio = resp.data.servicio;
        this.agendartodotiposervicio = resp.data.agendartodotiposervicio;
        this.incconelineaconta = resp.data.incconelineaconta;
        this.incconelineainven = resp.data.incconelineainven;
        this.servidorbdconta = resp.data.servidorbdconta;
        this.basedatosconta = resp.data.basedatosconta;
        this.usuarioconta = resp.data.usuarioconta;
        this.claveconta = resp.data.claveconta;
        this.servidorbdinven = resp.data.servidorbdinven;
        this.basedatosinven = resp.data.basedatosinven;
        this.usuarioinven = resp.data.usuarioinven;
        this.claveinven = resp.data.claveinven;
        this.tipoinventario = resp.data.tipoinventario;
        this.procesorequisicion = resp.data.procesorequisicion;
        this.hidecontacto = this.servicio == '1' ? false : true;

        if (this.estadoactividadincidencia != '1') {
          $("#estadoActividad").removeClass('col-sm-8').addClass('col-sm-12');
        }

        $('.chos-unit select[multiple]').chosen({
          placeholder_text_single: 'Seleccione Opción'
          , width: '100%'
          , no_results_text: 'Ooops, no se encuentra'
        });

        $('.chos-unit select[unitario]').chosen({
          placeholder_text_single: 'Seleccione Opción'
          , width: '100%'
          , no_results_text: 'Ooops, no se encuentra'
        });
      }

      setTimeout(function () {
        self.cargarDatatable();
      }, 0);
    });
  }// .paramCampos()

  /**
   * Permite abrir un modal para seleccionar la hora
   * JMM-2019-02-21
   */
  abrirModalHora(eventoclic, param) {
    if (param == 'divhorainicial') {
      this.eventoclic = (eventoclic == 1) ? 0 : 1;
      if (this.eventoclic == 0) {
        $('#divhorainicial').show();
      } else {
        $('#divhorainicial').hide();
      }
    }
    if (param == 'divhorafinal') {
      this.eventoclic = (eventoclic == 1) ? 0 : 1;
      if (this.eventoclic == 0) {
        $('#divhorafinal').show();
      } else {
        $('#divhorafinal').hide();
      }
    }
  }// .abrirModalHora(template:any)

  /**
   * Función para optener el listado de Tipos de pqr
   * JMM-2018-07-11
   */
  obtenerTipoPqr() {
    this._tipopqr.getTipoPqr().subscribe((resp) => {
      if (resp.data) {
        this.tipopqr = resp.data;
      }
    });
  }// .obtenerTipoPqr()

  /**
   * Función para optener el listado de PQR
   * JMM-2018-07-11
   */
  obtenerPqrs(pqrid) {
    this._pqr.getRegPqr(pqrid).subscribe((resp) => {
      if (this.idperfil == 'C' || this.idperfil == "CC") {
        $('select').attr('disabled', true);
      }
      if (resp.data) {
        // console.log(resp.data);
        this.registropqr.prioridadid = resp.data.prioridadid;
        this.formAcciones.controls.prioridadid.setValue(resp.data.prioridadid);
        this.pqrid = resp.data.pqrid;
        this.cierre = parseInt(resp.data.cierre);
        this.itemequipoid = resp.data.itemequipoid;
        //validación si la incidencia es preventova blocaque campo de asignar tecnicos
        if (resp.data.tipomantenimientoid > 0) {
          this.mostrarasignar = true;
        }
        //Si tiene asignado un coordinador
        if (resp.data.coordinadorid) {
          this.obtenerTecnicoCoordinador(resp.data.coordinadorid);
        }
        //Si llegan datos de la sucursal
        if (resp.data.sucursal) {
          this.registropqr = resp.data;
          this.registropqr.direccion = resp.data.direccionsucursal;
          this.registropqr.telefono = resp.data.telefonosucursal;
        }
        //Si no llegan datos de la sucursal muestra los datos de la correspondencia principal
        else {
          this.registropqr = resp.data;
          this.registropqr.direccion = resp.data.direcorre;
          this.registropqr.telefono = resp.data.telefcorre;
        }

        // Imagenes evidencias fotograficas
        this.registropqr.fotos.forEach((f: any) => {
          if (typeof f.contenido == 'string') {
            const foto = f.contenido.split(',');
            if (foto.length <= 1) {
              this.imagenesEvidenciasFotograficas.push(this.domSanitizer.bypassSecurityTrustResourceUrl(`data:image/jpg;base64,${f.contenido}`));
            } else {
              this.imagenesEvidenciasFotograficas.push(this.domSanitizer.bypassSecurityTrustResourceUrl(f.contenido));
            };
            
          };
        });

        //Si la incidencia esta cerrada se envia un estado desabled para no dejar hacer cambios en el tratamiento de la misma
        if (this.registropqr.cierre == 1) {
          this.estadotablacerrarActividad = this.registropqr.cierre;
          this.validaIncCierre = '1';
          this.cumplida = true;
          this.disabled = true;
          this.disabledReabrir = true;
          this.formAcciones.controls.prioridadid.disable();
          this.formAcciones.controls.tipopqrid.disable();
          this.formAcciones.controls.tiposervicioid.disable();
          if (this.registropqr.tipomantenimientoid == '1') {
            this.mostrarasignar = true;
          }
        } else {
          this.disabled = false;
          this.disabledReabrir = false;
          if (this.registropqr.tipomantenimientoid == '1') {
            this.mostrarasignar = true;
          } else {
            this.mostrarasignar = false;
          }
        }
        this.registropqr.listaschequeo = resp.data.listaschequeo;
        this.registropqr.listaschequeorespuesta = resp.data.listaschequeorespuesta;
        this.validaVersion = this.registropqr.cambiaversion == '1' ? true : false;
        this.GetComponentesEquipo(this.registropqr.itemequipoid, this.registropqr.itemcomponenteid);
        this.registropqr.horalimite = this.registropqr.horalimite ? this.registropqr.horalimite.split('.')[0] : '',
          this._agendamiento.listActividadesIncidencia(this.registropqr.pqrid).subscribe((respuesta) => {
            this.listActividades(this.registropqr.itemequipoid, respuesta);
            this.operacionesTiempo(this.registropqr.itemequipoid, this.registropqr.operacionid, this.registropqr.operacion);
          });

        this.registropqr.equipotercero = resp.data.equipoterceroid + ' - ' + resp.data.nombreequipo;
        this.gettransicionestado(this.registropqr.estadopqrid);
        //Obtener los datos del detalle de la PQR
        this.obtenerDetallesPqr(this.registropqr.pqrid);
        this.setHeadpqrInsumos();
        this.getIncAsignada();
        this.obtenerContactoTercero(this.registropqr.terceroid, this.registropqr.sucursalid);
        this.registropqr.colorfechalimite =  resp.data.colorfechalimite == null ? '#fff' : resp.data.colorfechalimite;
        const SPLIT_ARCHIVO = this.registropqr.archivo ? this.registropqr.archivo.split(';') : [];
        if (SPLIT_ARCHIVO.length > 1 ) {
          this.descargarVerArchivo = SPLIT_ARCHIVO[0].includes('image');
        }
      }// .if (resp.data)
    });
  }// .obtenerPqrs()

  obtenerContactoTercero(terceroid, sucursalid) {
    let self = this;
    this._contacto.obtenerContactoTercero(terceroid, sucursalid).subscribe((resp) => {
      for (let i = 0; i < resp.data.length; i++) {
        let cargo = resp.data[i].cargo ? ' Cargo - ' + resp.data[i].nombre : '';
        let profesion = resp.data[i].nombreprofesion ? ' Profesión - ' + resp.data[i].nombreprofesion : '';
        let telefono = resp.data[i].telefono ? ' Telefono - ' + resp.data[i].telefono : '';
        let dependencia = resp.data[i].dependencia ? ' Dependencia - ' + resp.data[i].dependencia : '';
        resp.data[i].nombre = resp.data[i].nombre + cargo + profesion + telefono + dependencia;
      }
      this.contactos = resp.data;
      setTimeout(function () {
        $('.contactoid').val(self.registropqr.contactoid).trigger('chosen:updated');
      }, 0);
    });
  }// .obtenerContacto(sucursalid)

  cargarDatatable() {
    let self = this;
    this.dtTblInsumos = $('#tblInsumopqr').DataTable({
      language: self.language,
      dom: 'domBftrlp',
      processing: true,
      pageLength: 10,
      scrollX: true,
      columnDefs: [
        {
          targets: [0],
          className: 'text-center',
          orderable: false,
        },
        {
          targets: [1, 5, 6],
          width: '1%',
          className: 'text-center',
        },
      ],
      buttons: self.buttons,
      createdRow: function (row, data, index) {
        if (data[6] > 0) {
          // $(row).find('td:eq(0) .btnEliminar').removeClass("hide");
        }

        $(row).on("click", ".btnEliminar", function (e) {
          e.preventDefault();
          swal({
            title: 'Esta Seguro de retirar la cantidad final?',
            text: "",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.value) {
              let datos = {
                headpqrinsumoid: $(row).find('td:eq(0) .btnEditarHE ').val()
              };
              self._tratamientopqr.eliminarRegInsumo(datos).subscribe((resp) => {
                if (resp.error) {
                  self.toastr.error('Ocurrio un Erorr', 'Error', { timeOut: 3000 });
                } else {
                  data[7] = '';
                  data[6] = '';
                  self.toastr.success('Cantidad final eliminada con éxito', '', { timeOut: 3000 });
                  $(row).find('td:eq(0) .btnActualizarHE').val('');
                  $(row).find('td:eq(0) .btnEliminar').val('').addClass("hide");
                  $(row).find('td:eq(6)').html('');
                }
              });
            }// .if / .else
          });
        });

        $(row).on("click", ".btnCancelarEdicionHEC", function (e) {
          e.preventDefault();
          $(row).find('td:eq(9)').html(data[9]);
          $(row).find('td:eq(0) .btnActualizarHE span').removeClass("glyphicon-floppy-disk").addClass("glyphicon-pencil");
          $(row).find('td:eq(0) .btn-primary').removeClass("btnActualizarHE").addClass("btnEditarHE");
          $(row).find('td:eq(0) .btnEditarHE').removeClass("btn-primary").addClass("btn-success");
          $(row).find('td:eq(0) .btnCancelarEdicionHEC').addClass("hide");
          if (data[6] > 0) {
            $(row).find('td:eq(0) .btnEliminar').removeClass("hide");
          };
          
        });

        $(row).on("click", ".btnEditarHE", function (e) {
          e.preventDefault();
          let stepInput = 1 / Math.pow(10, data[15] != null ? data[15] : 0);
          let input = `
            <div class="chos-unit" style="background: #fff; padding-left: 0px;">
              <input type="number" class="form-control input_form" step="${stepInput}">
            </div>`;

          $(row).find('td:eq(9)').html(input);
          $(row).find('td:eq(9) input').val(data[6]);
          $(row).find('td:eq(0) .btnEditarHE span').removeClass("glyphicon-pencil").addClass("glyphicon-floppy-disk");
          $(row).find('td:eq(0) .btnEditarHE').removeClass("btn-success").addClass("btn-primary");
          $(row).find('td:eq(0) .btn-primary').removeClass("btnEditarHE").addClass("btnActualizarHE");
          $(row).find('td:eq(0) .btn-primary').attr('title', "Actualizar");
          $(row).find('td:eq(0) .btnCancelarEdicionHEC').removeClass("hide");
          $(row).find('td:eq(0) .btnEliminar').addClass("hide");
          $(row).find('td:eq(0) .btnCancelarEdicionHEC').attr('title', "Cancelar edición");
          $(row).find('td:eq(9) input').on('change keyup', function (e) {
            let valor: any = String($(this).val());
            if (valor.includes('.') && (valor.split('.')[1].length > data[15])) {
              let valorFixed = parseFloat(valor).toFixed(data[15]);
              valor = parseFloat(valorFixed);
              $(this).val(valor);
            };
          });
        });

        $(row).off("click", ".btnActualizarHE").on("click", ".btnActualizarHE", function (e) {
          e.preventDefault();
          var cantfin = $(row).find('td:eq(9) input').val();
          if (cantfin > 0) {
            var headpqrinsumoid = $(row).find('td:eq(0) .btnActualizarHE').val();
            data[6] = cantfin;
            let datos = {
              headpqrinsumoid: headpqrinsumoid != 'null' ? headpqrinsumoid : null,
              cantfin: parseFloat(cantfin),
              pqrid: self.pqrid,
              productoid: data[2],
              cantini: data[5]
            };
            self._tratamientopqr.InsertUpdateInsumo(datos).subscribe((resp) => {
              if (resp.error) {
                self.toastr.error('Ocurrio un Erorr', 'Error', { timeOut: 3000 });
              } else {
                self.toastr.success('Registro Almacenado con éxito', '', { timeOut: 3000 });
                $(row).find('td:eq(0) .btnActualizarHE').val(resp.data);
                $(row).find('td:eq(0) .btnEliminar').val(resp.data);
                $(row).find('td:eq(9)').html(cantfin);
                $(row).find('td:eq(11)').html(parseFloat(cantfin) + parseFloat(data[10]));
                $(row).find('td:eq(0) .btnActualizarHE span').removeClass("glyphicon-floppy-disk").addClass("glyphicon-pencil");
                $(row).find('td:eq(0) .btn-primary').removeClass("btnActualizarHE").addClass("btnEditarHE");
                $(row).find('td:eq(0) .btnEditarHE').removeClass("btn-primary").addClass("btn-success");
                $(row).find('td:eq(0) .btnCancelarEdicionHEC').addClass("hide");
                $(row).find('td:eq(0) .btnEliminar').removeClass("hide");
              }
            });
          } else {
            self.toastr.error('La cantidad debe ser igual o superir a uno (1)', 'Error', { timeOut: 3000 });
            return;
          }
        });
      },
    });
    $("[id=tblInsumopqr] thead").addClass("thTDocs");
    $("[id=tblInsumopqr] tbody").addClass("tdTDocs");

    this.dtTblrelacionheadpqr = $('#relacionheadpqr').DataTable({
      language: self.language,
      dom: 'domBftrlp',
      lengthChange: false,
      searchig: false,
      processing: true,
      pageLength: 10,
      order: [1, 'asc'],
      columnDefs: [
        {
          targets: [0, 1,],
          className: 'text-center',
          width: '1%',
          orderable: false,
        },
        {
          targets: [2],
          width: '10%',
        },
        {
          targets: [3, 4],
          width: '20%',
        },
        {
          targets: [5],
          width: '70%',
        },
      ],
      buttons: self.buttons,
      createdRow: function (row, data, index) {
        $(row).find('td:eq(2)').css('background', data[6]);
        $(row).find('td:eq(1)').html('<a class="dirigetratamiento" tooltip="ir Tratamiento de la incidencia">' + data[1] + '</a>');

        $(row).find('.dirigetratamiento').on("click", function (e) {
          e.preventDefault();
          self.dirigetratamiento(data[1]);
        });

        $(row).find('.eliminarasignacion').on("click", function (e) {
          e.preventDefault();
          self.eliminarasignacion(data[7], data[1]);
        });
      },
    });
    $("[id=relacionheadpqr] thead").addClass("thTDocs");
    $("[id=relacionheadpqr] tbody").addClass("tdTDocs");
  }

  dirigetratamiento(pqrid) {
    swal({
      title: 'Esta seguro de ir al Tratamiento de la incidencia?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.router.navigate(['main/enrutamientos/enrutamientopqr/' + pqrid], { replaceUrl: true });
      }
    });
  }

  eliminarasignacion(id, pqrid) {
    swal({
      title: 'Esta seguro de retirar la relación de la incidencia: ' + pqrid + ' ?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this._tratamientopqr.eliminarasignacion(id).subscribe((resp) => {
          if (resp.error) {
            this.toastr.error('Ocurrio un Erorr', 'Error', { timeOut: 3000 });
          } else {
            this.toastr.success('Registro eliminado con éxito', '', { timeOut: 3000 });
            let opcionEnvio = 'Elimina Relacion incidencia: ' + pqrid + ' de la incidencia: ' + this.registropqr.pqrid;
            this._rastreo.setRastreo(opcionEnvio, 'Tratamiento Incidencia , relación Incidencia').subscribe((resp) => {
            }); // fin rastreo
            this.getIncAsignada();
          }
        });
      }
    });
  }

  setHeadpqrInsumos() {
    let filas = [];
    let data = {
      pqrid: this.registropqr.pqrid,
      operacionid: this.registropqr.operacionid
    }
    this._tratamientopqr.setHeadpqrInsumos(data).subscribe((resp) => {
      $.each(resp.data, function () {
        let btn = '';
        let btnEli = '';
        btn = "<button type='button' value='" + this.headpqrinsumoid + "' class='btnEditarHE btn btn-success btn-xs' title='Editar' style='margin-right:5px'><span class='glyphicon glyphicon-pencil'></span></button><button type='button' value='" + this.headpqrinsumoid + "' class='hide btn btn-danger btn-xs btnCancelarEdicionHEC' title='Eliminar'><span class='glyphicon glyphicon-remove'></span></button>";
        btnEli = "<button type='button' value='" + this.headpqrinsumoid + "' class='hide btn btn-danger btn-xs btnEliminar' title='Eliminar Cantidad'><span class='glyphicon glyphicon-remove'></span></button>";
        var fila = {
          0: btn + btnEli,
          1: this.tipo,
          2: this.productoid,
          3: this.producto,
          4: this.operacion,
          5: this.unidad,
          6: parseFloat(this.cantini),
          7: this.cantidadDisponible == '.00000000' ? 0 : parseFloat(this.cantidadDisponible),
          8: parseFloat(this.cantidaddescargada),
          9: parseFloat(this.cantpendientereq),
          10: parseFloat(this.cantreq),
          11: parseFloat(this.cantfin), 
          12: this.costo,
          13: this.observacion,
          14: this.headpqrinsumoid,
          15: this.decimalesCantidad
        };
        filas.push(fila);
      });
      this.dtTblInsumos.clear().draw();
      this.dtTblInsumos.rows.add(filas).draw();
    });
  }

  getIncAsignada() {
    let filas = [];
    this._tratamientopqr.getIncAsignada(this.registropqr.pqrid).subscribe((resp) => {
      $.each(resp.data, function () {
        let btn = '';
        btn = "<button type='button' value='" + this.relacionheadpqrid + "' class=' btn btn-danger btn-xs eliminarasignacion' title='Eliminar'><span class='glyphicon glyphicon-remove'></span></button>";
        var fila = {
          0: btn,
          1: this.pqridrelacionada,
          2: this.nombreestadopqr,
          3: this.equipo,
          4: this.nombre,
          5: this.asunto,
          6: this.colorhexadecimal,
          7: this.relacionheadpqrid
        };
        filas.push(fila);
      });
      this.dtTblrelacionheadpqr.clear().draw();
      this.dtTblrelacionheadpqr.rows.add(filas).draw();
    });
  }


  validaexistencia(proveedorid) {
    this._pqr.validaexistencia(proveedorid).subscribe((resp) => {
      if (resp.data.length > 0) {
        $('#costo').attr('disabled', false);
      } else {
        $('#costo').attr('disabled', true);
      }
    });
  }

  /**
   * Función para obtener el historial de estados de una PQR
   * JMM-2018-07-13
   */
  obtenerDetallesPqr(pqrid) {
    this.disabledCierreCactividad = false;
    this._tratamientopqr.getDetallesPqr(pqrid).subscribe((resp) => {
      this.validaexistencia(this.registropqr.coordinadorid);
      if (resp.data) {
        this.dtpqrArray = resp.data;
        if (resp.data[0].id) {
          this.id_detallepqr = resp.data[0].id;
        }

        //Obtener el coordinador asignado actual, obtener el id del detalle actual
        for (let repdata of resp.data) {
          if (repdata.estado_actualizado == 1) {
            if (repdata.cumplido == '1' || repdata.cumplido == '0') {
              this.detallepqr.cumplido = repdata.cumplido;
              this.cumplida = true;
            } else if (repdata.cumplido == '') {
              this.detallepqr.cumplido = '';
              this.cumplida = false;
            }
          }
        }

        this.registropqr.tipomantenimientoid = this.registropqr.tipomantenimientoid = '1' ? this.registropqr.tipomantenimientoid : '0';
        if (this.registropqr.esproveedor == '1' && this.registropqr.tipomantenimientoid == '1') {
          $("#tipomantenimiento_agenda").attr("disabled", true);
          $("#btnCrearEP").addClass("hidden");
        } else {
          $("#tipomantenimiento_agenda").attr("disabled", false);
          $("#btnCrearEP").removeClass("hidden");
        }
        if(this.cierre == 1) $("#tipomantenimiento_agenda").attr("disabled", true);
        //Obtener listado de tecnicos asignados
        this.obtenerTecnicosAsignadosPqr(this.id_detallepqr);
        //Obtener notas
        this.obtenerNotasDetallePqr(pqrid);
      }
    });
  }// .obtenerDetallesPqr(pqrid)

  /**
   * Función para obtener el listado de tecnicos asignados
   * JMM-2018-07-13
   */
  obtenerTecnicosAsignadosPqr(detallepqrid) {
    this.getTecnicos();
    this.detallepqriid = detallepqrid;
    this.tecnicosCierre = [];
    this.mostrarBotonRefreshCierreActividad = false;
    this.mostrarBotonRefresh = false;

    this._tecnicoasignadopqr.getTecnicoAsignadoPqr(detallepqrid).subscribe((res) => {
      this.tapqrArray = res.data; //Array de tecnicos asignados
      this.cantidadcamposasignados = res.data.length; //Variable para almacenar la cantidad de campos de los tecnicos asignados
      this._pqr.listActividadesTecnicosLogtiempo(this.registropqr.pqrid).subscribe((resp) => {
        if (this.usuarioCliente == 1) {
          $('select').prop('disabled', true);
          $('#tecnicodt').prop('disabled', true);
        }
        for (let j in resp.data) {
          // if (resp.data[j].usuarioinicio == this.tapqrArray[i].tecnicoid){
          //FORMATO DE FECHAS
          var fechainicial;
          var horainicial;
          if (resp.data[j].inicio != null) {
            fechainicial = (resp.data[j].inicio.substring(0, resp.data[j].inicio.length - 9)).replace(/^(\d{2})-(\d{2})-(\d{4})$/g, '$3-$2-$1');
            horainicial = resp.data[j].inicio.substring(11, resp.data[j].inicio.length - 3) == '00:00' ? '00:00' : resp.data[j].inicio.substring(11, resp.data[j].inicio.length - 3);
          } else {
            fechainicial = '0001-01-01';
            horainicial = ''
          }

          var fechafinal;
          var horafinal;
          if (resp.data[j].fin != null) {
            fechafinal = (resp.data[j].fin.substring(0, resp.data[j].fin.length - 9)).replace(/^(\d{2})-(\d{2})-(\d{4})$/g, '$3-$2-$1');
            horafinal = resp.data[j].fin.substring(11, resp.data[j].fin.length - 3) == '00:00' ? '00:00' : resp.data[j].fin.substring(11, resp.data[j].fin.length - 3);
          } else {
            fechafinal = '0001-01-01';
            horafinal = ''
          }
          if (resp.data[j].nombreusuarioinicio) {
            let diligenciado = 0;
            for (let i in this.tapqrArray) {
              if (resp.data[j].usuarioinicio == this.tapqrArray[i].tecnicoid) {
                diligenciado = 1;
              }
            }

            this.tecnicosCierre.push({
              'logtiempoinico': resp.data[j].logtiempoinico ? resp.data[j].logtiempoinico : '',
              'logtiempofin': resp.data[j].logtiempofin ? resp.data[j].logtiempofin : '',
              'tecnicoid': resp.data[j].usuarioinicio ? resp.data[j].usuarioinicio : '',
              'nombretecnico': resp.data[j].nombreusuarioinicio ? resp.data[j].nombreusuarioinicio : '',
              'tipoactividadid': resp.data[j].tipoactividadid ? resp.data[j].tipoactividadid : '',
              'nombreactividad': resp.data[j].nombre ? resp.data[j].nombre : '',
              'fechainicial': fechainicial == '0001-01-01' ? '' : fechainicial,
              'horainicial': horainicial,
              'fechafinal': fechafinal == '0001-01-01' ? '' : fechafinal,
              'horafinal': horafinal,
              'iniciada': fechainicial > '0001-01-01' ? '1' : '',
              'bloquearactividad': resp.data[j].tipoactividadid ? 'true' : 'false',
              'bloqueariniciar': fechainicial > '0001-01-01' ? 'true' : 'false',
              'bloquearfinalizar': fechafinal > '0001-01-01' ? 'true' : 'false',
              'detallepqrid': resp.data[j].detallepqrid ? resp.data[j].detallepqrid : '',
              'diligenciado': diligenciado
            });
          }
        }// .for

        for (let i in this.tapqrArray) {
          this.tecnicosCierre.push({
            'logtiempoinico': '',
            'logtiempofin': '',
            'tecnicoid': this.tapqrArray[i].tecnicoid,
            'nombretecnico': this.tapqrArray[i].nombretecnico,
            'tipoactividadid': '',
            'nombreactividad': '',
            'fechainicial': '',
            'horainicial': '',
            'fechafinal': '',
            'horafinal': '',
            'iniciada': '',
            'bloquearactividad': 'false',
            'bloqueariniciar': 'false',
            'bloquearfinalizar': 'false',
            'diligenciado': 0
          });
        }
      });
    });
  }// .obtenerTecnicosAsignadosPqr(detallepqrid)

  /**
   * Función para quitar un registro del listado de tecnicos asignados
   * JMM-2018-10-25
   */
  quitarTecnicoAsignadoEnListado(indice) {
    this.tapqrArray.splice(indice, 1); //elimina un elemento del arreglo segun indice
    this.mostrarBotonRefresh = true; //visualizar boton para deshacer cambios
  }

  /**
   * Función para obtener el listado de notas del detalle de una PQR
   * JMM-2018-07-13
   */
  obtenerNotasDetallePqr(pqrid) {
    this.notaArray = [];
    this.notaArrayHistorial = [];
    this._notadetallepqr.getNotaDetallePqr(pqrid).subscribe((resp) => {

      if (this.usuarioCliente == '1') {
        for (let i in resp.data) {
          if (resp.data[i].privado != '1') {
            if (resp.data[i].estado == null || resp.data[i].estado == '') {
              this.notaArray.push(resp.data[i]);
            } else {
              this.notaArrayHistorial.push(resp.data[i]);
            }
          }
        }
      } else {
        for (let i in resp.data) {
          if (resp.data[i].estado == null || resp.data[i].estado == '') {
            this.notaArray.push(resp.data[i]);
          } else {
            this.notaArrayHistorial.push(resp.data[i]);
          }
        }
      }
      $('.numerico').inputmask({
        'alias': 'numeric',
        rightAlign: false
      });
      let self = this;
      $(document).off('change', '#costo').on('change', '#costo', function () {
        var fecha = self.registropqr.fechapqr;
        let date = new Date(fecha);
        let anio = date.getFullYear();
        self._tratamientopqr.validarcosto($("#proveedorid").val(), anio, self.registropqr.pqrid).subscribe((resp) => {
          if (resp.data.length > 0) {
            var sumacosto = parseInt($('#costo').val()) + (resp.data[0].consumo ? parseInt(resp.data[0].consumo) : 0);
            if (sumacosto > resp.data[0].costoestimado) {
              $('#costo').val('');
              self.saldoconsumo = resp.data[0].consumo ? resp.data[0].costoestimado - parseInt(resp.data[0].consumo) : 0;
              self.noResultcosto = true;
            } else {
              self.noResultcosto = false;
            }
          } else {
            $('#costo').val('');
            self.saldoconsumo = 0;
            self.noResultcosto = true;
          }
        });
      });
    });
    this.archivonotaArray = [];
    this._notadetallepqr.getArchivoNotaDetallePqr(pqrid).subscribe((resp) => {
      if (resp.data) {
        this.archivonotaArray = resp.data;
      }
    });
  }

  validarcostoCambioProveedor() {
    $('#costo').val("");
    var fecha = this.registropqr.fechapqr;
    let date = new Date(fecha);
    let anio = date.getFullYear();
    this._tratamientopqr.validarcosto($("#proveedorid").val(), anio, this.registropqr.pqrid).subscribe((resp) => {
      if (resp.data.length > 0) {
        if (resp.data[0].costoestimado > 0) {
          $('#costo').attr('disabled', false);
        } else {
          $('#costo').attr('disabled', true);
        }
      }
    });
  }

  /**
  * Función para optener el listado de las tipos de servicio
  * JMM-2018-07-11
  */
  obtenerTipoServicio() {
    this._tiposervicio.getTipoServicio().subscribe((resp) => {
      if (resp.data) {
        this.tiposervicios = resp.data;
      }
    });
  }// .obtenerTipoServicio()

  /**
 * Función para optener el listado de las tipos de prioridad
 * CESAR ARIAS-2019-12-18
 */
  obtenerTipoprioridad() {
    this._prioridad.getPrioridad().subscribe((resp) => {
      if (resp.data) {
        this.tiposprioridad = resp.data;
      }
    });
  }// .obtenerTipoprioridad()

  /**
   * Función para optener el listado de estados de la pqr
   * JMM-2018-07-11
   */
  obtenerEstadopqr() {
    this.estadospqrCierre = [];
    this._estadopqr.getEstadopqr().subscribe((resp) => {
      if (resp.data) {
        this.estadospqr = resp.data;
        this.estadospqrCierre = resp.data;
      }
    });
  }// .obtenerEstadopqr()

  /**
   * PERMITE PERMITE CONSULTAR LA LA TRANSACUION DEL ESTADO SEGUNE EL ESTADO EN EL QUE SE ENCUENTRE LA INCIDENCIA
   * CAAA-2019-09-19
  */
  gettransicionestado($estadopqrid) {
    this.transicionestado = [];
    if ($estadopqrid != null) {
      this._estadopqr.gettransicionestado($estadopqrid).subscribe((resp) => {
        if (resp.data) {
          this.transicionestado = resp.data;
        }
        $('.pqrarelacionar').val('').trigger('chosen:updated');
      });
    } else {
      this.transicionestado = this.estadospqr;
    }
  }// .gettransicionestado()

  /**
   * Permite listar las dependencias
   * JMM-2018-07-11
   */
  getdependencia() {
    this.PATH = this._config.obtenerPath();
    let url = this.PATH + '/api/admin/dependencias';
    this.http.get(url, { headers: this._key.head() }).map(resp => resp.json()).subscribe(respuesta => {
      if (respuesta.data) {
        this.dependencias = respuesta.data;
      }
    });
  }

  getTecnicos() {
    this._tercero.getListTerceros('TE').subscribe((resp) => {
      this.tecnicosLista = resp.data;
    });
  }

  /**
   * Permite obtener el listado de usuarios por tipo
   * JMM-2018-07-12
   */
  obtenerUsuariosTipo(tipo) {
    if (tipo == 'TE') {
      this._tercero.getListTerceros(tipo).subscribe((resp) => {
        this.tecnicos = resp.data;
      });
    }
    if (tipo == 'CO') {
      this._usuarios.getListUsuariosPorTipo(tipo).subscribe((resp) => {
        let listcoordinadores = new Array();
        let listcoordinadores_aux = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            listcoordinadores.push(resp.data[i]);
            if ((parseInt(resp.data[i].cedula)) != (parseInt(this.registropqr.coordinadorid))) {
              listcoordinadores_aux.push(resp.data[i]);
            };
          };
        }
        this.coordinadores = listcoordinadores;
        this.listasignarcoordinadores = listcoordinadores_aux;
        this.coordinadores_aux = listcoordinadores_aux;
      });
    }
  }// .obtenerUsuariosTipo(tipo)

  /**
 * Permite obtener el listado de coordinadores
 * JMM-2018-11-08
 */
  obtenerCoordinadoresagenda() {
    this._usuarios.getListUsuariosPorTipo('CO').subscribe((resp) => {
      this.listCoordinador = resp.data;
      if (resp.data) {
        let coordinadoresArray = new Array();
        for (let i = 0; i < resp.data.length; i++) {
          coordinadoresArray.push(resp.data[i]);
        }
        this.coordinadorArray = coordinadoresArray;
      }
    });
  }//. obtenerCoordinadores()


  /**
   * Permite reasignar la incidencia a un coordinador
   * JMM-2019-01-24
   */
  reasignarCoordinador() {
    swal({
      title: 'Desea reasignar la incidencia a otro coordinador?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.registropqr.dependenciaid = ''
        for (let i in this.coordinadores) {
          if (this.formAcciones.value.reasignarcoordinadorid == this.coordinadores[i].cedula) {
            this.registropqr.dependenciaid = this.coordinadores[i].dependenciaid != ''
              && this.coordinadores[i].dependenciaid != 'null'
              && this.coordinadores[i].dependenciaid != null
              ? this.coordinadores[i].dependenciaid
              : '';
          }
        }

        let datareasignar = {
          'pqrid': this.formAcciones.value.pqrid,
          'coordinadorid': this.formAcciones.value.reasignarcoordinadorid,
          'dependenciaid': this.registropqr.dependenciaid,
          'incconelineaconta': this.incconelineaconta,
          'incconelineainven': this.incconelineainven,
          'servidorbdconta': this.servidorbdconta,
          'basedatosconta': this.basedatosconta,
          'usuarioconta ': this.usuarioconta,
          'claveconta': this.claveconta,
          'servidorbdinven': this.servidorbdinven,
          'basedatosinven': this.basedatosinven,
          'usuarioinven': this.usuarioinven,
          'claveinven': this.claveinven,
          'tipoinventario': this.tipoinventario
        }

        this._tratamientopqr.reasignarCoordinadorIncidencia(datareasignar).subscribe((resp) => {
          if (resp.error) {
            this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
            this.registropqr.reasignarcoordinadorid = '';
          } else {
            this.toastr.success('Asignación de la incidencia exitosa!', '', { timeOut: 3000 });
            this.router.navigate(['main/pqr'], { replaceUrl: true });
          }
        });
      }// .if
      else {
        this.registropqr.reasignarcoordinadorid = '';
      }// .else
    });
  }// .reasignarCoordinador()


  /**
   * Permite obtener el listado de tecnicos por coordinador
   * JMM-2018-07-12
   */
  obtenerTecnicoCoordinador(coordinadorid) {
    //Si llega el coordinadorid al escogerlo desde el formulario del tratamiento de la pqr
    if (this.formAcciones.value.coordinadorid) {
      this._tercero.getTecnicoCoordinador(this.formAcciones.value.coordinadorid).subscribe((resp) => {
        let listtecnicos = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            listtecnicos.push(resp.data[i]);
          };
        }
        this.tecnicoscoordinadores = listtecnicos;
        this.tecnicoscoordinadores_aux = listtecnicos;
      });
    } else {
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        this.tecnicoscoordinadores = resp.data;
        this.tecnicoscoordinadores_aux = resp.data;
      });
    }// .else
  }// .obtenerTecnicoCoordinador(coordinadorid)


  /**
   * Permite obtener el listado de tecnicos por coordinador
   * JMM-2019-01-24
   */
  obtenerOtrosTecnicosCoordinador() {
    let coordinadorid_aux = this.formAcciones.value.otrocoordinadorid ? this.formAcciones.value.otrocoordinadorid.split("-") : '';
    let coordinadorid = coordinadorid_aux[0] ? coordinadorid_aux[0].trim() : '';
    let pqrid = this.formAcciones.value.pqrid;
    if (this.registropqr.coordinadorid == '') {
      this.formAcciones.value.coordinadorid = coordinadorid;
    }
    //Valida que llegue el coordinadorid y que sea diferente al usuario que se encuentre logueado
    if ((coordinadorid != '') && (coordinadorid != this.getCedulaUsuario) && (coordinadorid != this.registropqr.coordinadorid)) {
      swal({
        title: 'Digite la clave del coordinador',
        html:
          this.formAcciones.value.otrocoordinadorid + '<br>' +
          '<input type="password" id="coordinador_id" class="swal2-input" autocomplete="off">',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => [$('#coordinador_id').val()]
      }).then(result => {
        if (result.value) {
          this._tratamientopqr.confirmarClaveCoordinador(pqrid, coordinadorid, result.value[0]).subscribe((resp) => {

            if (resp.data == 'true') {
              this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
                let listtecnicos = new Array();
                for (let i in resp.data) {
                  if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
                    listtecnicos.push(resp.data[i]);
                  };
                }
                this.tecnicoscoordinadores_aux = listtecnicos;
                this.tecnicosotroscoordinadores = listtecnicos;
              });
            }// .if
            else {
              this.toastr.error('Clave incorrecta', 'Error', { timeOut: 3000 });
              this.registropqr.otrocoordinadorid = '';
            }// .else
          });
        }// .if
      });
    }// .if
    //Valida que llegue el coordinadorid y que sea igual al usuarioque se encuentra logueado
    else if ((coordinadorid != '') && (coordinadorid == this.getCedulaUsuario)) {
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        let listtecnicos = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            listtecnicos.push(resp.data[i]);
          };
        }
        this.tecnicoscoordinadores_aux = listtecnicos;
        this.tecnicosotroscoordinadores = listtecnicos;
      });
    }// .else if
    //Valida que llegue el coordinadorid y que sea igual al usuarioque se encuentra logueado
    else if ((coordinadorid != '') && (coordinadorid == this.registropqr.coordinadorid)) {
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        let listtecnicos = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            listtecnicos.push(resp.data[i]);
          };
        }
        this.tecnicoscoordinadores = listtecnicos;
        this.tecnicoscoordinadores_aux = listtecnicos;
      });
    }// .else
  }// .obtenerOtrosTecnicosCoordinador()

  /**
* Permite obtener el listado de tecnicos por coordinador
* JMM-2019-01-24
*/
  obtenerOtrosTecnicosCoordinadorAgenda() {
    let coordinadorid_aux = this.formNuevaprogramacion.value.otrocoordinadorid ? this.formNuevaprogramacion.value.otrocoordinadorid.split("-") : '';
    let coordinadorid = coordinadorid_aux[0] ? coordinadorid_aux[0].trim() : '';
    let pqrid = this.formNuevaprogramacion.value.pqrid;

    //Valida que llegue el coordinadorid y que sea diferente al usuario que se encuentre logueado
    if ((coordinadorid != '') && (coordinadorid != this.getCedulaUsuario) && (coordinadorid != this.nuevaprogramacion.coordinadorid)) {
      swal({
        title: 'Digite la clave del coordinador',
        html:
          this.formNuevaprogramacion.value.otrocoordinadorid + '<br>' +
          '<input type="password" id="coordinador_id" class="swal2-input" autocomplete="off">',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => [$('#coordinador_id').val()]
      }).then(result => {
        if (result.value) {
          this._tratamientopqr.confirmar_clavecoordinadorAgenda(coordinadorid, result.value[0]).subscribe((resp) => {
            if (resp.data == 'true') {
              this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
                let listtecnicos = new Array();
                for (let i in resp.data) {
                  if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
                    listtecnicos.push(resp.data[i]);
                  };
                }
                this.tecnicoscoordinadores_aux = listtecnicos;
                this.tecnicosotroscoordinadores = listtecnicos;
              });
            } else {
              this.toastr.error('Clave incorrecta', 'Error', { timeOut: 3000 });
            }// .else
          });
        }// .if
      });
    }// .if
    //Valida que llegue el coordinadorid y que sea igual al usuarioque se encuentra logueado
    else if ((coordinadorid != '') && (coordinadorid == this.getCedulaUsuario)) {
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        let listtecnicos = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            listtecnicos.push(resp.data[i]);
          };
        }
        this.tecnicoscoordinadores_aux = listtecnicos;
        this.tecnicosotroscoordinadores = listtecnicos;
      });
    }// .else if
    //Valida que llegue el coordinadorid y que sea igual al usuarioque se encuentra logueado
    else if ((coordinadorid != '') && (coordinadorid == this.nuevaprogramacion.coordinadorid)) {
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        let listtecnicos = new Array();
        for (let i in resp.data) {
          if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
            listtecnicos.push(resp.data[i]);
          };
        }
        this.tecnicoscoordinadores = listtecnicos;
        this.tecnicoscoordinadores_aux = listtecnicos;
      });
    }// .else
  }// .obtenerOtrosTecnicosCoordinador()


  /**
   * Permite habilitar el campo para registrar el cumplimiento
   * JMM-2018-08-17
   */
  habilitarCampoCumplimiento(estadopqrid) {
    if (estadopqrid != '') {
      this._estadopqr.getRegEstadopqr(estadopqrid).subscribe((resp) => {
        if (resp.data.cierre == 1) {
          this.estadotablacerrarActividad = resp.data.cierre;
          this.cumplida = true;
          this.formAcciones.controls.prioridadid.disable();
          this.formAcciones.controls.tipopqrid.disable();
          this.formAcciones.controls.tiposervicioid.disable();
        } else {
          this.estadotablacerrarActividad = resp.data.cierre;
          this.detallepqr.cumplido = '';
          this.cumplida = false;
          this.validaVersion = false;
        }

        if (resp.data.cambiaversion == '1') {
          this.validaVersion = true;
        } else {
          this.validaVersion = false;
        }
      });
    }

  }// .habilitarCampoCumplimiento()

  /**
 * Permite habilitar y consultar los tipos de actividades
 * CAAA-2018-11-26
 */
  habilitarCampoTipoActividad(id_pqr) {
    let pqrid = this.registropqr.pqrid ? this.registropqr.pqrid : id_pqr;
    if(this.registropqr.tipomantenimientoid == '1') {
      this._pqr.obtenerActividadesIncidencia(pqrid).subscribe((resp) => {
        this.listaTipoActividad = resp.data;
      });
    } else {
      this._pqr.obtenerTipoActividades(pqrid).subscribe((resp) => {
        this.listaTipoActividad = resp.data;
      });
    }
  }// .habilitarCampoTipoActividad(id_pqr)

  /**
   * Permite  validar si la incidencia esta iniciada en la app al momento de cerrar la incidencia desde la web
   * CAA-2018-11-07
   */
  asignar() {
    this.asignarGuardar();
  }// .asignar()


  /**
 * Permite enviar la petición para cerrar los incidencias con actividades iniciadas
 * CAAA-2018-11-29
 */
  CerrararActividad() {
    let vampo_vacio = 0; //variable que define el contenido del campo, si es vacio=1, si es lleno=0
    var cantidadinputs1;
    var cantidadinputs2;
    let totalArryayActividadesCierre = new Array();
    cantidadinputs1 = $('#cantidadcampos').val();
    cantidadinputs2 = $('#cantidadcamposCierreActividad').val();

    for (var i = 0; i <= cantidadinputs2; i++) {
      if ($('#formatofinal_' + i).val() == undefined) {
        //validacion de campos requeridos en el cierre de las actividades
        if ($('#tecnicoidasignadoCierre_' + i).val() == '') {
          this.toastr.warning('Debe digitar tecnicoidasignado', '', { timeOut: 3000 });
          vampo_vacio = vampo_vacio + 1;
        }
        else if (this.registropqr.pqrid == '') {
          this.toastr.warning('Por favor espere que la incidencia cargue toda la información', '', { timeOut: 3000 });
          vampo_vacio = vampo_vacio + 1;
        }

        if ($('#fechainicialCierre_' + i).val() == '') {
          let alerta_div_fecha_inicial_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_fecha_inicial_' + i).html(alerta_div_fecha_inicial_);
          vampo_vacio = vampo_vacio + 1;
        } else {
          $('#alerta_div_fecha_inicial_' + i).html("");
        }

        if ($('#fechafinalCierre_' + i).val() == '') {
          let alerta_div_fecha_final_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_fecha_final_' + i).html(alerta_div_fecha_final_);
          vampo_vacio = vampo_vacio + 1;
        } else {
          $('#alerta_div_fecha_final_' + i).html("");
        }

        if ($('#horafinal_' + i).val() == '') {
          let alerta_div_horafinal_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_horafinal_' + i).html(alerta_div_horafinal_);
          vampo_vacio = vampo_vacio + 1;
        } else {
          $('#alerta_div_horafinal_' + i).html("");
        }

        if ($('#hora_Inicial_' + i).val() == '') {
          let alerta_div_hora_Inicial_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_hora_Inicial_' + i).html(alerta_div_hora_Inicial_);
          vampo_vacio = vampo_vacio + 1;
        } else {
          $('#alerta_div_hora_Inicial_' + i).html("");
        }

        if ($('#actividadCierre_' + i).val() == '') {
          let alerta_div_actividadCierre_ = (
            '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>'
          );
          $('#alerta_div_actividadCierre_' + i).html(alerta_div_actividadCierre_);
          vampo_vacio = vampo_vacio + 1;
        } else {
          $('#alerta_div_actividadCierre_' + i).html("");
        }

        if ($('#fechainicialCierre_' + i).val() > $('#fechafinalCierre_' + i).val()) {
          let alerta_div_fecha_final_mayor_ = (
            '<div class="alert alert-danger" style="padding: 5px;">La fecha Final debe ser igual o mayor a la fecha Inicial</div>'
          );
          if ($('#fechafinalCierre_' + i).val() != '') {
            $('#alerta_div_fecha_final_mayor_' + i).html(alerta_div_fecha_final_mayor_);
            $('#alerta_div_fecha_final_' + i).html("");
          }
          vampo_vacio = vampo_vacio + 1;
        }

        if ($('#fechainicialCierre_' + i).val() == $('#fechafinalCierre_' + i).val()) {

          if ($('#hora_Inicial_' + i).val() > $('#horafinal_' + i).val()) {
            let alerta_div_fecha_final_mayor_ = (
              '<div class="alert alert-danger" style="padding: 5px;">La hora Final debe ser  mayor a la hora Inicial</div>'
            );

            $('#alerta_div_fecha_final_mayor_' + i).html(alerta_div_fecha_final_mayor_);
            $('#alerta_div_fecha_final_' + i).html("");
            vampo_vacio = vampo_vacio + 1;
          } else {
            $('#alerta_div_fecha_final_mayor_' + i).html("");
          }
        } else {
          $('#alerta_div_fecha_final_mayor_' + i).html("");
          vampo_vacio = 0;
        }
        //Fin de validacion de campos requeridos en el cierre de las actividades

        //si vampo_vacio==0, quiere decir que todos los campos estan diligenciados
        if (vampo_vacio == 0) {
          let arregloDatosTecnicos2 = new Array;
          //valida los campos que no esten bloqueados y que se encuentren diligenciados
          if ($('#bloquearfinalizar_' + i).val() == 'false' && vampo_vacio == 0) {
            //FORMATO DE FECHAS
            var fechainicial;
            var fechainicial_aux;
            fechainicial = $('#fechainicialCierre_' + i).val().replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3-$2-$1');
            fechainicial_aux = fechainicial.split('-');
            fechainicial = fechainicial_aux[2] + '-' + fechainicial_aux[1] + '-' + fechainicial_aux[0];

            var fechafinal;
            var fechafinal_aux;
            fechafinal = $('#fechafinalCierre_' + i).val().replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3-$2-$1');
            fechafinal_aux = fechafinal.split('-');
            fechafinal = fechafinal_aux[2] + '-' + fechafinal_aux[1] + '-' + fechafinal_aux[0];

            let objetoDatosTecnicos = {
              'tecnicoid': $('#tecnicoCierre_' + i).val(),
              'pqrid': this.registropqr.pqrid,
              'fechainicial': fechainicial,
              'horaInicial': $('#hora_Inicial_' + i).val(),
              'formatoinicial': $('#formatoinicial_' + i).val(),
              'fechafinal': fechafinal,
              'horaFinal': $('#horafinal_' + i).val(),
              'actividad': $('#actividadCierre_' + i).val(),
              'iniciada': $('#iniciada_' + i).val(),
              'formatofinal': $('#formatofinal_' + i).val(),
            };

            arregloDatosTecnicos2.push(objetoDatosTecnicos);
            totalArryayActividadesCierre.push(arregloDatosTecnicos2[0]);
          }// .if ($('#bloquearfinalizar_'+i).val() ==  '' && vampo_vacio == 0)
        }// .if (vampo_vacio == 0)
      }//. if ($('#formatofinal_'+i).val() != undefined)
    } //.for (var i = 0; i <= 0; i ++)

    //valida nuevamente que los campos esten diligenciados
    if (vampo_vacio == 0) {
      let obj_ActividadesCierre = {
        'data_ActividadesCierre': totalArryayActividadesCierre,
      }
      /**
       * Permite enviar la petición para guardar los datos de cierre de actividades
       * CAAA-2019-01-10
       */
      this._pqr.cerrarActividadPqrWeb(obj_ActividadesCierre).subscribe((resp) => {
        if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
        } else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          this.tecnicosCierre = [];
          this.tapqrArray = [];
          this.obtenerDetallesPqr(this.registropqr.pqrid);
        }// .else
      });
    }//. if (vampo_vacio == 0) {
  }// .CerrararActividad()


  /**
   * Permite eliminar fila de la lista de actividades a cerrar
   * JMM-2019-01-09
   */
  quitarFila(i) {
    this.tecnicosCierre.splice(i, 1); //elimina un elemento del arreglo segun indice
    this.mostrarBotonRefreshCierreActividad = true; //visualizar boton para deshacer cambios
  }

  /**
   * Permite refrescar fila de la lista de actividades a cerrar
   * JMM-2019-01-09
   */
  RefreshCierreActividad() {
    $('#cerrarActividad').removeAttr('disabled', false);
    this.obtenerTecnicosAsignadosPqr(this.detallepqriid);
  }

  /**
   * Permite enviar la petición para guardar los datos
   * JMM-2019-01-09
   */
  asignarGuardar() {
    //Cantidad de filas de campos dinamicos
    var cantidadinputs2;
    //Arreglo de datos dinamicos
    let arregloDatosTecnicos1 = new Array;
    let arregloDatosTecnicos2 = new Array;
    let arregloDatosTecnicos_aux = new Array; //Array que almacena todos los registros concatenados incluyendo los undefined
    let arregloDatosTecnicos_aux2: any; //Objeto para almacenar temporalmente los registros que se validan con undefined
    let arregloDatosTecnicos_aux3 = new Array; //Array con registros limpios sin undefined
    let arregloDatosTecnicos = new Array;

    //Ciclo para recorrer los campos dinamicos asignados en el formulario
    for (let i in this.arrayAgregarTecnicos) {
      if (this.arrayAgregarTecnicos[i].tecnicoid != undefined) {
        let tecnicoid = '';
        let tecnicoid_aux = this.arrayAgregarTecnicos[i].tecnicoid ? this.arrayAgregarTecnicos[i].tecnicoid.split("-") : '';
        tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';
        let objetoDatosTecnicos = {
          'tecnicoid': tecnicoid,
          'costoproveedor': $('#costoProveedorNuevo_' + i).val() ? $('#costoProveedorNuevo_' + i).val() : null
        };
        arregloDatosTecnicos1.push(objetoDatosTecnicos);
      }
    }// .for


    //Ciclo para recorrer los campos dinamicos asignados en el formulario
    cantidadinputs2 = $('#cantidadcamposasignados').val();
    for (var k = 0; k <= cantidadinputs2; k++) {
      let tecnicoidasignado = '';
      //Se realiza un split para sacar los identificadores:
      let tecnicoidasignado_aux = $('#tecnicoidasignado_' + k).val() ? $('#tecnicoidasignado_' + k).val().split("-") : '';
      tecnicoidasignado = tecnicoidasignado_aux[0] ? tecnicoidasignado_aux[0].trim() : '';
      if (tecnicoidasignado != "") {
        let objetoDatosTecnicos = {
          'tecnicoid': tecnicoidasignado,
          'costoproveedor': $('#costoProveedorAntes_' + k).val() ? $('#costoProveedorAntes_' + k).val() : null
        };
        arregloDatosTecnicos2.push(objetoDatosTecnicos);
      }
    }// .for

    // --Bloque saber si existen registros duplicados
    let duplicados = 0;
    if (arregloDatosTecnicos1.length <= arregloDatosTecnicos2.length) {
      for (let i in arregloDatosTecnicos1) {
        for (let j in arregloDatosTecnicos2) {
          if (arregloDatosTecnicos1[i].tecnicoid != undefined && arregloDatosTecnicos1[i].tecnicoid != '' && arregloDatosTecnicos1[i].tecnicoid == arregloDatosTecnicos2[j].tecnicoid) {
            duplicados = 1;
          }
        }
      }
    }
    else if (arregloDatosTecnicos1.length > arregloDatosTecnicos2.length) {
      for (let i in arregloDatosTecnicos2) {
        for (let j in arregloDatosTecnicos1) {
          if (arregloDatosTecnicos1[j].tecnicoid != undefined && arregloDatosTecnicos1[j].tecnicoid != '' && arregloDatosTecnicos2[i].tecnicoid == arregloDatosTecnicos1[j].tecnicoid) {
            duplicados = 1;
          }
        }
      }
    }
    // --Fin bloque saber si existen registros duplicados

    //Validacion en caso que existan registros duplicados
    if (duplicados >= 1) {
      this.toastr.error('Ya existen técnicos asignados con el mismo número de identificación!', '', { timeOut: 3000 });
    } else {
      //Se concatenan los dos arreglos
      arregloDatosTecnicos_aux = arregloDatosTecnicos1.concat(arregloDatosTecnicos2);
      //Civlo para quitar los registros con undefined
      for (let x in arregloDatosTecnicos_aux) {
        if (arregloDatosTecnicos_aux[x].tecnicoid != undefined) {
          let tecnicoidasignado = '';
          let costo = '';
          // if(this.formAcciones.value.esproveedor == 1){
          //   tecnicoidasignado = this.formAcciones.value.coordinadorid;
          // }else{
          tecnicoidasignado = arregloDatosTecnicos_aux[x].tecnicoid
          costo = arregloDatosTecnicos_aux[x].costoproveedor
          // }

          arregloDatosTecnicos_aux2 = {
            'tecnicoid': tecnicoidasignado,
            'costoproveedor': costo
          };
          arregloDatosTecnicos_aux3.push(arregloDatosTecnicos_aux2);
        }
      }// .for

      // --Bloque eliminar registros duplicados
      var limpiaduplicados = {};
      for (let i in arregloDatosTecnicos_aux3) {
        limpiaduplicados[arregloDatosTecnicos_aux3[i]['tecnicoid']] = arregloDatosTecnicos_aux3[i];
      }
      for (let i in limpiaduplicados) {
        arregloDatosTecnicos.push(limpiaduplicados[i]);
      }
      // --Fin bloque eliminar registros duplicados
      var selected = [];
      $(".checkboxTratamiento").each(function () {
        if ($(this).is(":checked")) {
          selected.push({
            'actividadid': $(this).val(),
            'pqrid': '',
            'esactividadpqr': '1',
          });
        } else {
          selected.push({
            'actividadid': $(this).val(),
            'pqrid': '',
            'esactividadpqr': '0',
          });
        }
      }
      );
      this.formNuevaprogramacion.value.actividadid = selected;

      //arregloDatosTecnicos = arregloDatosTecnicos_aux;
      arregloDatosTecnicos = arregloDatosTecnicos.filter(Boolean);
      var fecha = this.registropqr.fechalimite ? this.registropqr.fechalimite : null;
      if (fecha != null) {
        if (this.registropqr.horalimite != null) {
          fecha = fecha + ' ' + this.registropqr.horalimite;
        }

        if (fecha < this.registropqr.fechapqr) {
          this.toastr.error('La fecha limite no puede ser menor a la fecha de la incidencia *', 'Error', { timeOut: 3000 });
          return;
        }
      }

      this.registropqr.itemcomponenteid = $('#itemcomponenteid').val();
      this.registropqr.componenteequipoid = $('#componenteequipoid').val();

      //DATOS PARA GUARDAR EN BASE DE DATOS
      let dataTratamientoPqr = {
        //DATOS PARA HEADPQR
        'pqrid': this.formAcciones.value.pqrid,
        'dependenciaid': this.registropqr.dependenciaid,
        'ticket': this.formAcciones.value.ticket,
        'coordinadorid': this.formAcciones.value.coordinadorid,
        'presupuestoplaneado': this.formAcciones.value.presupuestoplaneado,
        'tipomantenimientoid': this.formAcciones.value.tipomantenimientoid,
        'asunto': this.registropqr.asunto,
        'equipoterceroid': this.registropqr.equipoterceroid,
        'descripcion': this.registropqr.descripcion,
        'estadopqrid': this.registropqr.estadopqrid,
        'versionid': this.registropqr.versionid,
        'prioridadid': this.formAcciones.controls.prioridadid.value,
        'tiposervicioid': this.registropqr.tiposervicioid,
        'tipopqrid': this.registropqr.tipopqrid,
        'usuario_edito': this.getUsuarioId,
        'fechalimite': fecha,
        'horalimite': this.registropqr.horalimite,
        // 'actividadid'         : this.registropqr.actividadid,
        'actividadid': this.formNuevaprogramacion.value.actividadid,
        'created_at': this.registropqr.created_at,
        //DATOS ACTUALIZAR PARA DETALLEPQR
        'id': $('#id_detallepqr').val(),
        'estado_actualizado': 0,
        //DATOS CREAR PARA DETALLEPQR
        'cumplido': this.formAcciones.value.cumplido,
        'esproveedor': this.formAcciones.value.esproveedor,
        'costo': $('#costo').val(),
        'itemcomponenteid': this.registropqr.itemcomponenteid,
        'componenteequipoid': this.registropqr.componenteequipoid,
        'detalle': this.formAcciones.value.detalle,
        //DATOS PARA TECNICOASIGNADOPQR
        dataTecnicoasignado: {
          'cantidadregistros': arregloDatosTecnicos.length,
          subdata: {
            'detallepqrid': '',
            arrayDataTecnicos: arregloDatosTecnicos
          }
        },
        //ACTIDADES
        listactividades: this.tecnicosCierre
      }

      //  valida si el mantenimiento es preventivo solo requiere el estadoid
      if (this.formAcciones.value.tipomantenimientoid == 1) {
        if (this.registropqr.estadopqrid != '') {
          this.submit(dataTratamientoPqr);
        } else {
          this._valid.touched(this.formAcciones);
          this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
        }
      } else {
        //Si validacion erronea del formulario muestra mensaje
        if (!this.formAcciones.valid) {
          this._valid.touched(this.formAcciones);
          this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
        } else {
          this.submit(dataTratamientoPqr);
        }// .else
      }
    }// .else
  }// .asignarGuardar()


  //GUARDAR DATOS DEL TRATAMIENTO PQR
  submit(dataTratamientoPqr) {
    this._tratamientopqr.setCreateUpdateTratamientoPqr(dataTratamientoPqr).subscribe((resp) => {
      if (resp.error) {
        this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
      } else {
        this.toastr.success('Transacción exitosa', '', { timeOut: 3000 });
        this.router.navigate(['main/enrutamientos/enrutamientopqr/' + this.formAcciones.value.pqrid], { replaceUrl: true });
      }
    });
  }

  editActividad(j, bloqueariniciar, bloquearfinalizar) {
    $('#actividadCierre_' + j).val() != '' ? $('#actividadCierre_' + j).removeAttr('disabled', false) : '';
    $('#cerrarActividad').prop('disabled', true);

    if (bloqueariniciar == 'true') {
      $('#fechainicialCierre_' + j).removeAttr('disabled', false);
      $('#hora_Inicial_' + j).removeAttr('disabled', false);
    } else {
      $('#fechainicialCierre_' + j).prop('disabled', true).val('');
      $('#hora_Inicial_' + j).prop('disabled', true).val('');
    }
    if (bloquearfinalizar == 'true') {
      $('#fechafinalCierre_' + j).removeAttr('disabled', false);
      $('#horafinal_' + j).removeAttr('disabled', false);
    } else {
      $('#fechafinalCierre_' + j).prop('disabled', true).val('');
      $('#horafinal_' + j).prop('disabled', true).val('');
    }

    $('#btneditActividad_' + j).addClass('hidden');
    $("#btnsubmitEdit_" + j).removeClass('hidden');
  }


  submitEdit(j, bloqueariniciar, bloquearfinalizar) {
    let validadorcampo = '<div class="alert alert-danger" style="padding: 5px;">El campo es requerido</div>';
    let campo_vacio = 0;
    let actividadCierre = $('#actividadCierre_' + j).val();
    let logtiempoinicio = $('#logtiempoinico_' + j).val();
    let logtiempocierre = $('#logtiempofin_' + j).val();
    let fechainicialCierre = $('#fechainicialCierre_' + j).val();
    let hora_inicio = $('#hora_Inicial_' + j).val();
    let fechafinalcierre = $('#fechafinalCierre_' + j).val();
    let horafinal = $('#horafinal_' + j).val();

    //validacion de campos requeridos en el cierre de las actividades
    if ($('#tecnicoidasignadoCierre_' + j).val() == '') {
      this.toastr.warning('Debe digitar tecnicoidasignado', '', { timeOut: 3000 });
      campo_vacio = campo_vacio = + 1;

    }
    else if (this.registropqr.pqrid == '') {
      this.toastr.warning('Por favor espere que la incidencia cargue toda la información', '', { timeOut: 3000 });
      campo_vacio = campo_vacio = + 1;
    }
    // valida si el campo viene deligenciado desde base de datos  no lo permita guardar al modificar vacio fecha inicial
    if (bloqueariniciar == 'true') {
      if ($('#actividadCierre_' + j).val() == '') {
        $('#alerta_div_actividadCierre_' + j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;

      }
      else {
        $('#alerta_div_actividadCierre_' + j).html("");
      }

      if (fechainicialCierre == '') {
        $('#alerta_div_fecha_inicial_' + j).html(validadorcampo);
        campo_vacio = campo_vacio = + 1;

      } else {
        $('#alerta_div_fecha_inicial_' + j).html("");
      }

      if (hora_inicio == '') {
        $('#alerta_div_hora_Inicial_' + j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;
      } else {
        $('#alerta_div_hora_Inicial_' + j).html("");
      }
    }
    // valida si el campo viene deligenciado desde base de datos  no lo permita guardar al modificar vacio fecha final
    if (bloquearfinalizar == 'true') {
      if ($('#actividadCierre_' + j).val() == '') {
        $('#alerta_div_actividadCierre_' + j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;
      } else {
        $('#alerta_div_actividadCierre_' + j).html("");
      }

      if (fechafinalcierre == '') {
        $('#alerta_div_fecha_final_' + j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;
      } else {
        $('#alerta_div_fecha_final_' + j).html("");
      }

      if (horafinal == '') {
        $('#alerta_div_horafinal_' + j).html(validadorcampo);
        campo_vacio = campo_vacio + 1;
      } else {
        $('#alerta_div_horafinal_' + j).html("");
      }
    }
    if (fechainicialCierre > fechafinalcierre && bloquearfinalizar == 'true' && bloqueariniciar == 'true') {
      let alerta_div_fecha_final_mayor_ = (
        '<div class="alert alert-danger" style="padding: 5px;">La fecha Final debe ser igual o mayor a la fecha Inicial</div>'
      );
      $('#alerta_div_fecha_final_mayor_' + j).html('<div class="alert alert-danger" style="padding: 5px;">La fecha Final debe ser igual o mayor a la fecha Inicial</div>');
      $('#alerta_div_fecha_final_' + j).html(alerta_div_fecha_final_mayor_);
      campo_vacio = campo_vacio + 1;
    }
    if ($('#fechainicialCierre_' + j).val() == $('#fechafinalCierre_' + j).val()) {
      if ($('#hora_Inicial_' + j).val() > $('#horafinal_' + j).val()) {
        let alerta_div_fecha_final_mayor_ = (
          '<div class="alert alert-danger" style="padding: 5px;">La hora Final debe ser  mayor a la hora Inicial</div>'
        );
        $('#alerta_div_fecha_final_mayor_' + j).html(alerta_div_fecha_final_mayor_);
        $('#alerta_div_fecha_final_' + j).html("");
        campo_vacio = campo_vacio + 1;
      } else {
        $('#alerta_div_fecha_final_mayor_' + j).html("");
      }
    }
    else {
      $('#alerta_div_fecha_final_mayor_' + j).html("");
    }

    if (campo_vacio == 0) {
      let dataedit = {
        'pqrid': this.registropqr.pqrid,
        'tecnicoid': $('#tecnicoCierre_' + j).val(),
        'actividadCierre': actividadCierre,
        'logtiempoinicio': logtiempoinicio ? logtiempoinicio : null,
        'logtiempocierre': logtiempocierre,
        'fechainicialCierre': fechainicialCierre,
        'hora_inicio': hora_inicio,
        'fechafinalcierre': fechafinalcierre,
        'horafinal': horafinal,
        'dataAutorizo': this.dataAutorizo
      }
      //EDITAR DATOS
      $('#cerrarActividad').removeAttr('disabled', false);
      this._pqr.editarActividadPqrWeb(dataedit).subscribe((resp) => {
        if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
          $("#btneditActividad_" + j).removeClass('hidden');
          $('#btnsubmitEdit_' + j).addClass('hidden');
        } else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          this.tecnicosCierre = [];
          this.tapqrArray = [];
          this.obtenerDetallesPqr(this.registropqr.pqrid);
        }
      });
      $("#btneditActividad_" + j).removeClass('hidden');
      $('#btnsubmitEdit_' + j).addClass('hidden');
    } else {
      this.toastr.warning('Campos requeridos', '', { timeOut: 3000 });
    }
  }

  /**
   * Permite enviar la petición a un servicio para eliminar el registro
   * CESAR ARIAS-2019-04-02
   */
  eliminarActividad(j, logtiempoinico, logtiempofin, $dataAutorizo) {
    swal({
      title: 'Esta seguro de eliminar el registro?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        let dataeliminar = {
          'logtiempoinico': logtiempoinico,
          'logtiempofin': logtiempofin,
          'dataAutorizo': $dataAutorizo
        }
        this._pqr.eliminarActividad(dataeliminar).subscribe((resp) => {
          if (resp.error) {
            this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
            $("#btneditActividad_" + j).removeClass('hidden');
            $('#btnsubmitEdit_' + j).addClass('hidden');
          }// .if
          else {
            this.toastr.success(resp.message, '', { timeOut: 3000 });
            this.tecnicosCierre = [];
            this.tapqrArray = [];
            this.obtenerDetallesPqr(this.registropqr.pqrid);
          }// .else
        });
      } // .if (result.value)
    });
  }// .enviarEliminar()

  /**
  * Permite enviar la petición a un servicio para eliminar el registro
  * CESAR ARIAS-2019-04-02
  */
  validaUasuarioAutorizador($accion, $file, $param1, $param2) {
    this.dataAutorizo = '';
    if (this.getUsuarioId == 'prosof') {
      if ($accion == 'Editar') {
        this.editActividad($file, $param1, $param2);
      } else if ($accion == 'Eliminar') {
        this.eliminarActividad($file, $param1, $param2, null);
      }
    } else {
      swal({
        title: 'Digite Usuario y contraseña coordinador',
        html:
          '<input type="text" id="coordinadorAutoriza_id" placeholder="Usuario..." class="swal2-input" autocomplete="off">' +
          '<input type="password" id="paswwordcoordinadorAutoriza_id" placeholder="password..." class="swal2-input" autocomplete="off">',
        text: "",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          let usuarioValidar = {
            'usuarioid': $('#coordinadorAutoriza_id').val(),
            'clave': $('#paswwordcoordinadorAutoriza_id').val()
          }
          this._pqr.validaUasuarioAutorizador(usuarioValidar).subscribe((resp) => {
            if (resp.data.length > 0) {
              //datos para el rastreo de la persona que autorizo el la accion
              this.dataAutorizo = {
                'nombre': resp.data[0]['nombre'],
                'usuarioid': resp.data[0]['usuarioid'],
                'cedula': resp.data[0]['cedula'],
              }
              this._perfiles.getPermisos(resp.data[0]['usuarioid'], resp.data[0]['perfilid']).subscribe((resp) => {
                let listpermisosAutoriza = this._perfiles.getObjectPermisosUsuarios(resp.data);
                if (listpermisosAutoriza.autorizar_gestion_atctividades_de_agendamiento == true) {
                  if ($accion == 'Editar') {
                    this.editActividad($file, $param1, $param2);
                  } else if ($accion == 'Eliminar') {
                    this.eliminarActividad($file, $param1, $param2, this.dataAutorizo);
                  }
                } else {
                  this.toastr.warning('el cordinador no tiene permisos para autorizar la acción', '', { timeOut: 3000 });
                }
              });
            } else {
              this.toastr.warning('Por favor digite una contraseña correcta', '', { timeOut: 3000 });
            }
          });
        } // .if (result.value)
      });
    }//this.getUsuarioId == 'prosof'
  }// .enviarEliminar()


  /**
   * Permite enviar la petición para cancelar la nota
   * JMM-2018-07-12
   */
  cancelar() {
    this.router.navigate(['main/pqr'], { replaceUrl: true });
  }// .cancelar()

  /**
   * Permite adicionar campos dinamicos en el formulario
   * JMM-2018-07-18
   */
  adicionarCampos() {
    var newItemNo;
    newItemNo = this.campos.length + 4;
    this.campos.push({ 'id': 'campo1' + newItemNo });
    this.cantidadcampos = '' + this.campos.length;
    this.activarAdicionarCampos = false;
  }// .adicionarCampos()

  /**
 * Permite adicionar campos dinamicos en el formulario
 * JMM-2018-07-18
 */
  adicionarCamposAgenda() {
    var newItemNo;
    newItemNo = this.camposAgenda.length + 4;
    this.camposAgenda.push({ 'id': 'campo1' + newItemNo });
    this.cantidadcamposAgenda = '' + this.camposAgenda.length;
    this.activarAdicionarCampos = false;
  }// .adicionarCampos()

  /**
   * Permite eliminar campos dinamicos de el formulario
   * JMM-2018-07-18
   */
  quitarCampos() {
    var lastItem = this.campos.length - 1;
    this.campos.push({ 'id': 'campo1' + lastItem });
    this.cantidadcampos = '' + lastItem;
    this.campos.splice(lastItem);
    this.activarAdicionarCampos = true;
  }// .quitarCampos()

  /**
   * Permite adicionar a una lista los técnicos que se van a asignar
   * JMM-201901-23
   */
  agregarTecnicos(param) {
    if (param == 1) {
      for (let i = 0; i <= $('#cantidadcampos').val(); i++) {
        //Se realiza un split para sacar los identificadores:
        let tecnicoid_aux = $('#tecnicoid_' + i).val() ? $('#tecnicoid_' + i).val().split("-") : '';
        let tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';

        if ($('#tecnicoid_' + i).val() != '' && $('#tecnicoid_' + i).val() != undefined) {
          // valida que el tecnico seleccionado no se encuentre en la tabla de tecnicos antes asignados
          let comparador = 0;
          if (this.tapqrArray) {
            for (let j = 0; j <= this.tapqrArray.length - 1; j++) {
              if (this.tapqrArray[j]['tecnicoid'] == tecnicoid) {
                comparador = comparador + 1;
              }
            }
          }

          if (this.arrayAgregarTecnicos) {
            for (let j = 0; j <= this.arrayAgregarTecnicos.length - 1; j++) {
              if (this.arrayAgregarTecnicos[j].cedula == tecnicoid) {
                comparador = comparador + 1;
              }
            }
          }

          //Valida si existe un tecnico asignado
          if ($('#tecnicoid_' + i).val() != undefined && comparador > 0) {
            this.toastr.error('Ya existe un técnico con el mismo número de identificación en la lista de nuevos técnicos asignar!', '', { timeOut: 3000 });
            return;
          }
          //De lo contrario lo asigna
          else if (comparador == 0) {
            this.fototercero(tecnicoid, $('#tecnicoid_' + i).val());

          } else {
            this.toastr.error('El técnico seleccionado ya se encuentra en la lista de técnicos antes asignados!', '', { timeOut: 3000 });
            return;
          }
        }
      }// .for
    }// .if
    else if (param == 2) {
      for (let i = 0; i <= $('#cantidadcampos').val(); i++) {
        //Se realiza un split para sacar los identificadores:
        let tecnicoid_aux = $('#otrotecnicoid_' + i).val() ? $('#otrotecnicoid_' + i).val().split("-") : '';
        let tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';

        if ($('#otrotecnicoid_' + i).val() != '' && $('#otrotecnicoid_' + i).val() != undefined) {
          // valida que el tecnico seleccionado no se encuentre en la tabla de tecnicos antes asignados
          let comparador = 0;
          if (this.tapqrArray) {
            for (let j = 0; j <= this.tapqrArray.length - 1; j++) {
              if (this.tapqrArray[j]['tecnicoid'] == tecnicoid) {
                comparador = comparador + 1;
              }
            }
          }

          if (this.arrayAgregarTecnicos) {
            for (let j = 0; j <= this.arrayAgregarTecnicos.length - 1; j++) {
              if (this.arrayAgregarTecnicos[j].cedula == tecnicoid) {
                comparador = comparador + 1;
              }
            }
          }

          //Valida si existe un tecnico asignado
          if ($('#otrotecnicoid_' + i).val() != undefined && comparador > 0) {
            this.toastr.error('Ya existe un técnico con el mismo número de identificación en la lista de nuevos técnicos asignar!', '', { timeOut: 3000 });
            return;
          }
          //De lo contrario lo asigna
          else if (comparador == 0) {
            this.fototercero(tecnicoid, $('#otrotecnicoid_' + i).val());
          } else {
            this.toastr.error('El técnico seleccionado ya se encuentra en la lista de técnicos antes asignados!', '', { timeOut: 3000 });
            return;
          }
        }
      }// .for
    }// .else if
  }// .agregarTecnicos()

  fototercero(terceroid, otrotecnicoid) {
    this._pqr.fototercero(terceroid).subscribe((resp) => {
      if (resp.data.length > 0) {
        this.arrayAgregarTecnicos.push({ 'cedula': terceroid, 'tecnicoid': otrotecnicoid, 'foto': resp.data[0].foto });
      } else {
        this.arrayAgregarTecnicos.push({ 'cedula': terceroid, 'tecnicoid': otrotecnicoid, 'foto': '' });
      }
    });
  }
  /**
   * Permite obtener el listado de tecnicos de acuerdo al coordinador
   * JMM-2018-11-08
   */
  obtenerlistadotecnicodetallepqr(detallepqrid) {
    //Si llega el id del detalle de la pqr
    if (detallepqrid) {
      this._agendamiento.getTecnicosAsignados(detallepqrid).subscribe((resp) => {
        if (resp.data) {
          let listatecnicos = new Array();
          for (let i in resp.data) {
            listatecnicos.push(resp.data[i].tecnicoid);
          }
          this.tecnicoagendamientoArray_aux = listatecnicos;
        }
        this.listTecnico_aux = [];
        for (let i in resp.data) {
          this.listTecnico_aux.push(resp.data[i].tecnicoid);
        }
        this.tecnicoagendamientoArray = this.listTecnico_aux;
        /**
         * Esta funcionalidad permite sacar el identificador y el nombre de los tecnicos selecionados
         * CESAR
         */
        for (let i in resp.data) {
          let semaforo = 1;
          for (let j in this.listTecnicosDetallePqr) {
            if (this.listTecnicosDetallePqr[j].tecnicoid == resp.data[i].tecnicoid) {

              if (semaforo == 1) {
                this.TecnicoList.push(this.listTecnicosDetallePqr[j]);
                semaforo = 0;
              }
            }
          }
        }
      });
    }
  }// .obtenerlistadotecnicodetallepqr(coordinadorid)

  /**
   * Permite adicionar a una lista los técnicos que se van a asignar  en agenda
   * CESAR ARIAS-2019-08-28
   */
  agregarTecnicosAgenda(param) {
    if (param == 1) {
      for (let i = 0; i <= $('#cantidadcamposgenda').val() - 1; i++) {
        //Se realiza un split para sacar los identificadores:
        let tecnicoid_aux = $('#tecnicoidagenda').val() ? $('#tecnicoidagenda').val().split("-") : '';
        let tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';

        if ($('#tecnicoidagenda').val() != '' && $('#tecnicoidagenda').val() != undefined) {
          // valida que el tecnico seleccionado no se encuentre en la tabla de tecnicos antes asignados
          let comparador = 0;
          if (this.TecnicoList) {
            for (let j = 0; j <= this.TecnicoList.length - 1; j++) {
              if (this.TecnicoList[j]['tecnicoid'] == tecnicoid) {
                comparador = comparador + 1;
              }
            }
          }

          //Valida si existe un tecnico asignado
          if (($('#tecnicoidagenda').val() != undefined) && (this.arrayAgregarTecnicosAgenda.includes($('#tecnicoidagenda').val())) && (comparador == 0)) {
            this.toastr.error('Ya existe un técnico con el mismo número de identificación en la lista de nuevos técnicos asignar!', '', { timeOut: 3000 });
          }
          //De lo contrario lo asigna
          else if (comparador == 0) {
            this.arrayAgregarTecnicosAgenda.push($('#tecnicoidagenda').val());
          } else {
            this.toastr.error('El técnico seleccionado ya se encuentra en la lista de técnicos antes asignados!', '', { timeOut: 3000 });
          }
        }
      }// .for
    }// .if
    else if (param == 2) {
      for (let i = 0; i <= $('#cantidadcamposgenda').val() - 1; i++) {
        //Se realiza un split para sacar los identificadores:
        let tecnicoid_aux = $('#otrotecnicoidAgenda').val() ? $('#otrotecnicoidAgenda').val().split("-") : '';
        let tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';

        if ($('#otrotecnicoidAgenda').val() != '' && $('#otrotecnicoidAgenda').val() != undefined) {
          // valida que el tecnico seleccionado no se encuentre en la tabla de tecnicos antes asignados
          let comparador = 0;
          if (this.TecnicoList) {
            for (let j = 0; j <= this.TecnicoList.length - 1; j++) {
              if (this.TecnicoList[j]['tecnicoid'] == tecnicoid) {
                comparador = comparador + 1;
              }
            }
          }
          //Valida si existe un tecnico asignado
          if (($('#otrotecnicoidAgenda').val() != undefined) && (this.arrayAgregarTecnicosAgenda.includes($('#otrotecnicoidAgenda').val())) && (comparador == 0)) {
            this.toastr.error('Ya existe un técnico con el mismo número de identificación en la lista de nuevos técnicos asignar!', '', { timeOut: 3000 });
          } else if (comparador == 0) {
            this.arrayAgregarTecnicosAgenda.push($('#otrotecnicoidAgenda').val());
          } else {
            this.toastr.error('El técnico seleccionado ya se encuentra en la lista de técnicos antes asignados!', '', { timeOut: 3000 });
          }
        }
      }// .for
    }// .else if
  }// .agregarTecnicos()


  /**
   * Permite eiliminar un elemento de listado de tecnicos que se van a asignar por medio de un indice
   * JMM-2019-01-23
   */
  quitarTecnicoDeListado(i) {
    this.arrayAgregarTecnicos.splice(i, 1);
  }// .quitarTecnicoDeListado(i)

  /**
  * Permite eiliminar un elemento de listado de tecnicos que se van a asignar por medio de un indice
  * JMM-2019-01-23
  */
  quitarTecnicoDeListadoAgenda(i) {
    this.arrayAgregarTecnicosAgenda.splice(i, 1);
  }// .quitarTecnicoDeListado(i)

  /**
   * Permite activar cpara reabrir la incidencia
   * CAAA-2018-11-08
   */
  reabrir() {
    if (this.disabledReabrir == true) {
      this.disabledReabrir = false;
      this.accion = 'Cancelar';
      this.mostrarasignar = false;
      this.cierre = 0;
      this.formAcciones.controls.prioridadid.enable();
      this.formAcciones.controls.tipopqrid.enable();
      this.formAcciones.controls.tiposervicioid.enable();
    } else {
      this.disabledReabrir = true;
      this.accion = '';
      this.cierre = 1;
      this.formAcciones.controls.prioridadid.disable();
      this.formAcciones.controls.tipopqrid.disable();
      this.formAcciones.controls.tiposervicioid.disable();
      //  this.mostrarasignar = true;
    }
  }

  /**
 * Permite activar cpara reabrir la incidencia perfil cliete
 * CAAA-2018-11-08
 */
  reabrirIncCliente() {
    this._estadopqr.reabrirIncCliente(this.registropqr.pqrid).subscribe(resp => {
      this._rastreo.setRastreo('Cliente Reabre Incidencia: ' + this.registropqr.pqrid, 'Tratamiento de la Incidencia').subscribe((resp) => {
        this.toastr.success('Datos guardados exitosamente', '', { timeOut: 3000 });
        this.router.navigate(['main/enrutamientos/enrutamientopqr/' + this.registropqr.pqrid], { replaceUrl: true });
      });
    })
  }


  /**
   * Permite subir los archivos seleccionados
   * JMM-2018-07-31
   */
  subirArchivos(event: any) {
    var archivos;
    if (event.target.files && event.target.files) {
      var limit = 1024; //Limite de subida del archivo
      var filesAmount = event.target.files.length; //Cantidad de archivos
      //Ciclo para recorrer los archivos que se van a subir
      for (let i = 0; i < filesAmount; i++) {
        var fileSize = parseInt(event.target.files[i].size);
        var siezekiloByte = fileSize / limit;

        //Validacion en caso que los archivos sean muy grandes
        if (siezekiloByte > event.target.files[i].size) {
          this.toastr.error('El archivo excede el tamañao permitido.', 'Error', { timeOut: 3000 });
        } else {
          this.urls_archivos = [];
          this.tipo_archivos = [];
          var extension = event.target.files[i].type;
          var reader = new FileReader(); //Instanciamos FileReader para recorrer los archivos y convertirlos a base64
          reader.onloadend = (event) => {
            this.urls_archivos.push(reader.result); //Se guardan los archivos codificados en base64 en un array
            this.tipo_archivos.push(extension); //Se guardan las extensiones de los archivos en un array
          }
          reader.readAsDataURL(event.target.files[i]);
        }// .else
      }// .for

      //Se almacenan los datos de los archivos a subir en un objeto
      archivos = {
        'pqrid': $('#id_pqr').val(),
        'detallepqrid': $('#id_detallepqr').val(),
        'archivo': this.urls_archivos, //Obtenemos el contenido del archivo codificado en Base64
        'extension': this.tipo_archivos,
        'usuario_asigno': this.getUsuarioId
      }

      this.detallepqr.archivosanexos = archivos;
      //Rretornar el objeto con los archivos anexos
      return this.detallepqr.archivosanexos;
    }// .if
  }// .subirArchivos(event:any)


  /**
   * Permite enviar la petición para guardar las notas
   * JMM-2018-07-12
   */
  asignarNota() {
    //ARCHIVOS ANEXOS EN LA NOTA
    let archivosanexos = this.formNotas.value.archivosanexos;
    let archivos;
    var privado = '';
    $("#privado").each(function () {
      if ($(this).is(":checked")) {
        privado = '1';
      } else {
        privado = '0';
      }
    }
    );

    //CICLO PARA GUARDAR LOS ARCHIVOS ANEXOS EN LA NOTA
    for (let i in archivosanexos.archivo) {
      archivos = {
        'detallepqrid': archivosanexos.detallepqrid,
        'archivo': archivosanexos.archivo[i],
        'extension': archivosanexos.extension[i],
        'usuario_asigno': archivosanexos.usuario_asigno
      }
    }// .for

    //DATOS PARA CREAR LA NOTA
    let crear_notaDetallepqr = {
      'detallepqrid': $('#id_detallepqr').val(),
      'detalle': this.formNotas.value.detalle,
      'usuario_asigno': this.getUsuarioId,
      'pqrid': this.formNotas.value.pqrid, //Dato para hacer el enrutamiento
      'archivos': archivos,
      'privado': privado,
    }

    //Si validacion erronea del formulario muestra mensaje
    if (!this.formNotas.value.detalle) {
      this._valid.touched(this.formNotas);
      this.toastr.error('Debe digitar un texto', 'Error', { timeOut: 3000 });
    } else {
      //GUARDAR DATOS
      this._notadetallepqr.setNotaDetallePqr(crear_notaDetallepqr).subscribe((resp) => {
        if (resp.data == 'formatoarchivoerror') {
          this.toastr.error('Formato de archivo incorrecto.', 'Error', { timeOut: 3000 });
        }
        else if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
        } else {
          this.toastr.success('Transacción exitosa', '', { timeOut: 3000 });
          this.router.navigate(['main/enrutamientos/enrutamientopqr/' + crear_notaDetallepqr.pqrid], { replaceUrl: true });
        }
      });
    }// .else

  }// .asignarNota()


  /**
   * Permite buscar los tecnicos que se encuentran dentro del historico del detalle de la pqr
   * JMM-2018-07-12
   */
  mostrarTecnicosPorDetallePqrId(template: any, detallepqrid) {
    this.listTecnicosDetallePqr = [];
    this._tecnicoasignadopqr.getTecnicoAsignadoPqr(detallepqrid).subscribe((resp) => {
      if (resp.data.length > 0) {
        this.mostrarDatos = true;
        this.noMostrarDatos = false;
        this.obtenerlistadotecnicodetallepqr(detallepqrid);
        this.listTecnicosDetallePqr = resp.data;
      } else {
        this.mostrarDatos = false;
        this.noMostrarDatos = true;
      }
    });
  }// .mostrarTecnicosPorDetallePqrId()


  /**
   * Recibe como parametro el template y la url del archivo para visualizarlo
   * JMM-2018-08-28
   */
  visualizarImagenes(template: any, urlarchivo, extensionArchivo = '') {
    let extencionUrl = urlarchivo.split(';')[0].includes('image') ? 'image' : 'doc';
    this.extensionArchivo = extensionArchivo === '' ? extencionUrl : extensionArchivo;
    //Se limpia la url del archivo
    this.urlarchivo = this.domSanitizer.bypassSecurityTrustResourceUrl(urlarchivo);
    //Se abre la ventana modal
    this.modalRef = this.modalService.show(template, { backdrop: 'static', keyboard: false, class: 'gray modal-lg' });
  }// .visualizarImagenes(template:any, urlarchivo)

  /**
   * Recibe como parametro el template y la url del archivo para descargarlo
   * JMM-2019-01-22
   */
  descargarVisualizarArchivos(template: any, urlarchivo) {
    //Se limpia la url del archivo
    this.urlarchivo = this.domSanitizer.bypassSecurityTrustResourceUrl(urlarchivo);
    //Se abre la ventana modal
    this.modalRef = this.modalService.show(template, { backdrop: 'static', keyboard: false, class: 'gray modal-sm' });
  }// .descargarVisualizarArchivos(template:any, urlarchivo)

  descargarArchivo(archivo: any) {
    const downloadlink = document.createElement('a');
    downloadlink.href = archivo;
    downloadlink.setAttribute('download', 'adjunto-pqr');
    document.body.appendChild(downloadlink);
    downloadlink.click();
    document.body.removeChild(downloadlink);
    this.toastr.success('Descargando archivo');
  }

  /**
   * Permite validar el formulario
   * JMM-2018-07-12
   */
  createForm() {
    this.formAcciones = new FormGroup({
      //CAMPOS DE LA PQR
      'pqrid': new FormControl(this.registropqr.pqrid),
      'created_at': new FormControl(this.registropqr.created_at),
      'fechapqr': new FormControl(this.registropqr.fechapqr),
      'fechalimite': new FormControl(this.registropqr.fechalimite),
      'horalimite': new FormControl(this.registropqr.horalimite),
      'ticket': new FormControl(this.registropqr.ticket),
      'tipopqrid': new FormControl(this.registropqr.tipopqrid, [Validators.required]),
      'tiposervicioid': new FormControl(this.registropqr.tiposervicioid, [Validators.required]),
      'cliente': new FormControl(this.registropqr.nombrecliente),
      'identificacion': new FormControl(this.registropqr.terceroid),
      'direccion': new FormControl(this.registropqr.direccion),
      'telefono': new FormControl(this.registropqr.telefono),
      'mediosoporte': new FormControl(this.registropqr.nombremediosoporte),
      'asunto': new FormControl(this.registropqr.asunto),
      'descripcion': new FormControl(this.registropqr.descripcion),
      'dependenciaid': new FormControl(this.registropqr.dependenciaid),
      'coordinadorid': new FormControl(this.registropqr.coordinadorid),
      'presupuestoplaneado': new FormControl(this.registropqr.presupuestoplaneado),
      'versionid': new FormControl(this.registropqr.versionid),
      'versionactual': new FormControl(this.registropqr.versionactual),
      'prioridadid': new FormControl(this.registropqr.prioridadid, [Validators.required]),
      'valorfrecuencia': new FormControl(this.registropqr.valorfrecuencia),
      'tiempo': new FormControl(this.registropqr.tiempo),
      'sucursal': new FormControl(this.registropqr.sucursal),
      'sucursalid': new FormControl(this.registropqr.sucursalid),
      'direccionsucursal': new FormControl(this.registropqr.direccionsucursal),
      'telefonosucursal': new FormControl(this.registropqr.telefonosucursal),
      'visibilidad': new FormControl(this.registropqr.visibilidad),
      'nversion': new FormControl(this.registropqr.nversion),
      'equipoterceroid': new FormControl(this.registropqr.equipoterceroid),
      'tipomantenimientoid': new FormControl(this.registropqr.tipomantenimientoid, [Validators.required]),
      'reasignarcoordinadorid': new FormControl(this.registropqr.reasignarcoordinadorid),
      'otrocoordinadorid': new FormControl(this.registropqr.otrocoordinadorid),
      'originadopor': new FormControl(this.registropqr.originadopor),
      'itemcomponenteid': new FormControl(this.registropqr.itemcomponenteid),
      'componenteequipoid': new FormControl(this.registropqr.componenteequipoid),
      'nombresubcomponente': new FormControl(this.registropqr.nombresubcomponente),
      'esproveedor': new FormControl(this.registropqr.esproveedor),
      'costo': new FormControl(this.registropqr.costo),
      //CAMPOS DEL DETALLE DE LA PQR
      'tecnicoid': new FormControl(this.detallepqr.detallepqr),
      'estadopqrid': new FormControl(this.detallepqr.estadopqr, [Validators.required]),
      'cumplido': new FormControl(this.detallepqr.cumplido),
      //CAMPOS DEL LOG TIEMPO
      'actividadid': new FormControl(this.registropqr.actividadid),
      'cotizacion': new FormControl(this.registropqr.cotizacion),
      'operacionid': new FormControl(this.registropqr.operacionid),
      'nombrcomer': new FormControl(this.registropqr.nombrcomer),
      'serial': new FormControl(this.registropqr.serial),
      'codigointerno': new FormControl(this.registropqr.codigointerno),
    });
  }// .createForm()

  /**
   * Permite validar el formulario
   * JMM-2018-07-12
   */
  createFormNotas() {
    this.formNotas = new FormGroup({
      'pqrid': new FormControl(this.registropqr.pqrid),
      'detalle': new FormControl(this.detallepqr.detalle),
      'files': new FormControl(this.detallepqr.files),
      'archivosanexos': new FormControl(this.detallepqr.archivosanexos)
    });
  }// .createFormNotas()


  /* *************************************************************************************************************** */
  /**
   * Permite abrir ventana modal
   * JMM-2018-11-14
   */
  abrirAgendamiento(template: any, pqrid) {
    this.disabledcampo = true;
    this.mostrarCampo = true;
    this.mostrarBotonHabilitarModificar = false;
    this.accion = (pqrid > 0) ? 'Editar' : 'Crear';
    this.modalRef = this.modalService.show(AgendamientoAppComponent, {
      backdrop: 'static',
      keyboard: false,
      class: 'gray modal-lg modal_agenda'
    });
    $('.modal-backdrop').fadeIn();
  }// .abrirAgendamiento(template:any, pqrid)

  /**
   * Permite abrir ventana modal
   * JMM-2018-11-14
   */
  crearAgendamiento(template: any, pqrid) {
    this.disabledcampo = true;
    this.mostrarCampo = true;
    this.mostrarBotonHabilitarModificar = true;
    this.accion = (pqrid > 0) ? 'Editar' : 'Crear';

    this._agendamiento.getRegistroAgendamiento('null', pqrid).subscribe((resp) => {
      if (resp.data.length > 0) {
        this.nuevaprogramacion.serial = (resp.data[0].serial ? resp.data[0].serial : '');
        this.nuevaprogramacion.agendamientoid = resp.data[0].agendamientoid;
        this.nuevaprogramacion.dependenciaid = resp.data[0].dependenciaid;
        this.nuevaprogramacion.fechaagendaid = resp.data[0].fechaagendaid;
        this.nuevaprogramacion.detallepqrid = resp.data[0].detallepqrid;
        this.nuevaprogramacion.alertapqrid = resp.data[0].alertapqrid;
        this.nuevaprogramacion.colorhexadecimal = resp.data[0].colorhexadecimal;
        this.nuevaprogramacion.pqrid = resp.data[0].pqrid;
        this.nuevaprogramacion.ticket = resp.data[0].ticket;
        this.nuevaprogramacion.fecha = resp.data[0].fecha;
        this.nuevaprogramacion.horainicial = resp.data[0].horainicial;
        this.nuevaprogramacion.horafinal = resp.data[0].horafinal;
        this.nuevaprogramacion.estado = resp.data[0].estado;
        this.nuevaprogramacion.tipopqrid = resp.data[0].tipopqrid;
        this.nuevaprogramacion.estadopqrid = resp.data[0].estadopqrid;
        this.nuevaprogramacion.cierre = resp.data[0].cierre;
        this.nuevaprogramacion.tiposervicioid = resp.data[0].tiposervicioid;
        this.nuevaprogramacion.terceroid = resp.data[0].clienteid ? resp.data[0].clienteid + '=>' + resp.data[0].nombrecliente : '';
        this.nuevaprogramacion.sucursalid = resp.data[0].sucursalid ? resp.data[0].sucursalid + '=>' + resp.data[0].nombresucursal : '';
        this.nuevaprogramacion.equipoterceroid = resp.data[0].equipoterceroid ? resp.data[0].equipoterceroid + '=>' + resp.data[0].nombreequipo + ' Serial->' + (resp.data[0].serial ? resp.data[0].serial : '') : '';
        this.nuevaprogramacion.coordinadorid = resp.data[0].coordinadorid;
        this.nuevaprogramacion.asunto = resp.data[0].asunto;
        this.nuevaprogramacion.descripcion = resp.data[0].descripcion;
        this.nuevaprogramacion.fechafinal = resp.data[0].fechafinal;
        this.nuevaprogramacion.prioridadid = resp.data[0].prioridadid;
        this.nuevaprogramacion.esproveedor = resp.data[0].esproveedor ? resp.data[0].esproveedor : this.registropqr.esproveedor;
        this.mostrarTecnicosPorDetallePqrId(null, resp.data[0].detallepqrid);

        //Obtener listado de tecnicos asignados
        this.obtenerlistadotecnico(resp.data[0].detallepqrid, resp.data[0].coordinadorid);
        this.obtenerlistadotecnicoAgenda(resp.data[0].coordinadorid);
        this._agendamiento.listActividadesIncidencia(resp.data[0].pqrid).subscribe((respuesta) => {
          this.listActividades(resp.data[0].itemequipoid, respuesta);
          this.operacionesTiempo(resp.data[0].itemequipoid, resp.data[0].operacionid, resp.data[0].operacion);
        });
      } else {
        this.nuevaprogramacion.agendamientoid = '';
        this.nuevaprogramacion.colorhexadecimal = '';
        this.nuevaprogramacion.fechaagendaid = '';
        this.nuevaprogramacion.detallepqrid = '';
        this.nuevaprogramacion.alertapqrid = '';
        this.nuevaprogramacion.pqrid = this.registropqr.pqrid;
        this.nuevaprogramacion.ticket = this.registropqr.ticket;
        this.nuevaprogramacion.fecha = this.registropqr.created_at;
        this.nuevaprogramacion.horainicial = '';
        this.nuevaprogramacion.horafinal = '';
        this.nuevaprogramacion.estado = '';
        this.nuevaprogramacion.tipopqrid = this.registropqr.tipopqrid;
        this.nuevaprogramacion.estadopqrid = this.registropqr.estadopqrid;
        this.nuevaprogramacion.tiposervicioid = this.registropqr.tiposervicioid;
        this.nuevaprogramacion.terceroid = this.registropqr.terceroid ? this.registropqr.terceroid + '=>' + this.registropqr.nombrecliente : '';
        this.nuevaprogramacion.sucursalid = this.registropqr.sucursalid ? this.registropqr.sucursalid + '=>' + this.registropqr.nombresucursal : '';
        this.nuevaprogramacion.equipoterceroid = this.registropqr.equipoterceroid ? this.registropqr.equipoterceroid + '=>' + this.registropqr.equipotercero + ' Serial->' + (this.registropqr.serial ? this.registropqr.serial : '') : '';
        this.nuevaprogramacion.coordinadorid = this.registropqr.coordinadorid;
        this.nuevaprogramacion.asunto = this.registropqr.asunto;
        this.nuevaprogramacion.descripcion = this.registropqr.descripcion;
        this.nuevaprogramacion.fechafinal = this.registropqr.created_at;
        this.nuevaprogramacion.prioridadid = this.registropqr.prioridadid;
        this.nuevaprogramacion.operacionid = this.registropqr.operacionid ? this.registropqr.operacionid : '';
        this.nuevaprogramacion.operacion = this.registropqr.operacion ? this.registropqr.operacion : '';

        this.registropqr.operacionid ? (this.nuevaprogramacion.validadoperaciontiempo = '1') : (this.nuevaprogramacion.validadoperaciontiempo = '0');
        this._agendamiento.listActividadesIncidencia(this.registropqr.pqrid).subscribe((respuesta) => {
          this.listActividades(this.registropqr.itemequipoid, respuesta);
          this.operacionesTiempo(this.registropqr.itemequipoid, this.registropqr.operacionid, this.registropqr.operacion);
        });
        //Obtener listado de tecnicos asignados
        this.obtenerlistadotecnico('', this.registropqr.coordinadorid);
      }
    });
    this.modalRef = this.modalService.show(template, { backdrop: 'static', keyboard: false, class: 'gray modal-lg modal_agenda' });
  }

  /**
   * Permite habilitar los campos para actualizar los datos
   * CESAR ARIAS -2019-05-06
   */
  listActividades(itemequipoid, dataactividad) {
    this.totalActividadesFamilia = [];
    if (this.registropqr.listaschequeorespuesta != null) {
      this.estadoactividadincidencia = '1';
      $("#estadoActividad").addClass('col-sm-8');
      this.totalActividadesFamilia = [...this.totalActividadesFamilia, ...dataactividad.data];
    } else {
      this._equipoTercero.listActividadesItemequipo(itemequipoid).subscribe((resp) => {
        if (this.idperfil == 'C' || this.idperfil == "CC") {
          $('select').attr('disabled', true);
        }
        for (let i in resp.data) {
          let param = 0;
          for (let j in dataactividad.data) {
            if (resp.data[i].tipoactividadid == dataactividad.data[j].actividadid) {
              param = param + 1;
              this.totalActividadesFamilia.push(dataactividad.data[j]);
            }
          }
          if (param == 0) {
            this.totalActividadesFamilia.push(
              {
                actividadpqr: '0',
                actividadid: resp.data[i].tipoactividadid,
                pqrid: '',
                nombre: resp.data[i].nombre
              }
            )
          }
        }
      });
    }
  }
  /**
   * Permite obtener el listado de tecnicos de acuerdo al coordinador
   * JMM-2018-11-08
   */
  obtenerlistadotecnico(detallepqrid, coordinadorid) {
    //Si llega el id del detalle de la pqr
    if (detallepqrid) {
      this._agendamiento.getTecnicosAsignados(detallepqrid).subscribe((resp) => {
        this.listTecnico_aux = [];
        for (let i in resp.data) {
          let objetoDatosTecnicos = {
            'tecnicoid': resp.data[i].tecnicoid
          };
          this.listTecnico_aux.push(objetoDatosTecnicos);
        }
        this.tecnicoagendamientoArray = this.listTecnico_aux;
      });
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        this.listTecnico = resp.data;
      });
    } else if (coordinadorid) {
      this._tercero.getTecnicoCoordinador(coordinadorid).subscribe((resp) => {
        this.listTecnico = resp.data;
      });
    } else {
      this._tercero.getTecnicoCoordinador(this.formNuevaprogramacion.value.coordinadorid).subscribe((resp) => {
        this.listTecnico = resp.data;
      });
    }
    this.obtenerDependenciaCoordinador()
  }// .obtenerlistadotecnico(coordinadorid)


  /**
    * Permite obtener el listado de tecnicos de acuerdo al coordinador
    * JMM-2018-11-08
    */
  obtenerlistadotecnicoAgenda(coordinadorid) {
    this._tercero.getTecnicoCoordinador(this.nuevaprogramacion.coordinadorid).subscribe((resp) => {
      if (resp.data != '') {
        this.listTecnicoporCordinador = resp.data;
      } else {
        this.listTecnicoporCordinador = [];
      }
    });
    this.tecnicosotroscoordinadores = [];
    this.obtenerUsuariosAgendaTipo('CO', this.nuevaprogramacion.coordinadorid)
  }
  /**
* Permite obtener el listado de usuarios por tipo
* JMM-2018-07-12
*/
  obtenerUsuariosAgendaTipo(tipo, coordinadorid) {
    this.listcoordinadores_aux = [];
    this._usuarios.getListUsuariosPorTipo(tipo).subscribe((resp) => {
      for (let i in resp.data) {
        if (resp.data[i].estadoid == 'A' || resp.data[i].estadoid == null) {
          if ((parseInt(resp.data[i].cedula)) != (parseInt(coordinadorid))) {
            this.listcoordinadores_aux.push(resp.data[i]);
          };
        };
      }
    });
  }// .obtenerUsuariosTipo(tipo)


  /**
   * Función para quitar un registro del listado de tecnicos asignados
   * CESAR ARIAS-2019-08-28
   */
  quitarTecnicoAntesasignado(indice) {
    this.TecnicoList.splice(indice, 1); //elimina un elemento del arreglo segun indice
  }// .quitarTecnicoAsignadoEnListado(indice)

  /**
   * Permite habilitar los campos para actualizar los datos
   * JMM-2018-11-13
   */
  habilitarModificar() {
    this.accion = 'Editar';
    this.disabledcampo = false;
    this.disabledBtnGuardar = false;
    this.mostrarBotonHabilitarModificar = false;
  }// .habilitarModificar()

  /**
   * Permite obtener el listado de coordinadores
   * JMM-2018-11-08
   */
  obtenerCoordinadores() {
    this._usuarios.getListUsuariosPorTipo('CO').subscribe((resp) => {
      this.listCoordinador = resp.data;
    });
  }//. obtenerCoordinadores()

  /**
   * Permite obtener el listado de terceros por tipo
   * JMM-2018-11-08
   */
  obtenerTerceros(tipo) {
    if (tipo == 'C') {
      this._tercero.getListTerceros(tipo).subscribe((resp) => {
        if (resp.data.length > 0) {
          //DATALIST
          //Se recorren los datos y se llena un array con la clave del identificador del tercero
          this.statesClienteCrear = [];
          var parametroCliente_aux = {};
          for (var i in resp.data) {
            parametroCliente_aux[resp.data[i]['terceroid']] = resp.data[i];
          }
          //Se recorre nuevamente el array con la clave del identificador del tercero y se eliminan los duplicados
          for (let i in parametroCliente_aux) {
            this.statesClienteCrear.push({
              'terceroid': parametroCliente_aux[i].terceroid,
              'nombre': parametroCliente_aux[i].nombre,
              'infocliente': parametroCliente_aux[i].terceroid + ' => ' + parametroCliente_aux[i].nombre
            });
          }
        } else {
          this.sindatos = 'No hay datos.';
        }
      });
    }
  }// .obtenerTerceros_filtro(tipo)

  /**
   * Permite obtener el listado de sucursales
   * JMM-2018-11-08
   */
  obtenerSucursal(terceroid) {
    //Validacion para limpiar los campos de la sucursal y del equipo
    if (terceroid) {
      this.nuevaprogramacion.sucursalid = '';
      this.nuevaprogramacion.equipoterceroid = '';
    }

    this._sucursal.getSucursales(terceroid).subscribe(resp => {
      if (resp.data.length > 0) {
        //DATALIST
        //Se inicializa el array
        this.statesSucursalCrear = [];
        //Se recorren los datos y se llena un array con la clave del identificador de la sucursal
        var parametroSucursal_aux = {};
        for (var j in resp.data) {
          parametroSucursal_aux[resp.data[j]['sucursalid']] = resp.data[j];
        }
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (let j in parametroSucursal_aux) {
          this.statesSucursalCrear.push({
            'terceroid': parametroSucursal_aux[j].terceroid,
            'sucursalid': parametroSucursal_aux[j].sucursalid,
            'nombre': parametroSucursal_aux[j].nombre,
            'infosucursal': parametroSucursal_aux[j].sucursalid + ' => ' + parametroSucursal_aux[j].nombre
          });
        }
      } else {
        this.sindatos = 'No hay datos.';
      }
    });
  }// .obtenerSucursal(id_tercero)

  /**
   * Permite obtener el listado de equipos por tercero
   * JMM-2018-11-08
   */
  obtenerEquiposTercero(terceroid) {
    //Validacion para limpiar el campo del equipo
    if (terceroid) {
      this.nuevaprogramacion.equipoterceroid = '';
    }

    this._equipoTercero.listEquipoTerceroPorTercero(terceroid).subscribe(respuesta => {
      //DATALIST
      //Se inicializa el arreglo
      this.statesEquipoCrear = [];
      if (respuesta.data.length > 0) {
        var parametroEquipo_aux = {};
        for (var i in respuesta.data) {
          parametroEquipo_aux[respuesta.data[i]['equipoterceroid']] = respuesta.data[i];
        }
        //Se asigna un dato vacio como cabecera del array
        this.statesEquipoCrear.push({ 'equipoterceroid': '' });
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroEquipo_aux) {
          this.statesEquipoCrear.push({
            'itemequipoid': parametroEquipo_aux[i].itemequipoid,
            'equipoterceroid': parametroEquipo_aux[i].equipoterceroid,
            'nombre': parametroEquipo_aux[i].nombreequipo,
            'infoequipo': parametroEquipo_aux[i].equipoterceroid + ' => ' + parametroEquipo_aux[i].nombreequipo + ' - ' + parametroEquipo_aux[i].modelo + ' Serial=>' + (parametroEquipo_aux[i].serial != null ? parametroEquipo_aux[i].serial : '')
          });
        }
      } else {
        this.sindatos = 'No hay datos.';
      }
    });
  }// .obtenerEquiposTercero_crear(terceroid)

  /**
   * olista todas las operacionesde tiempo del equipo inventariado
   * CESAR ARIAS -2019-05-07
   */
  operacionesTiempo(itemequipoid, operaionid, operacion) {
    this._pqr.operacionesTiempo(itemequipoid).subscribe((resp) => {
      this.statesOperacion = [];
      //DATALIST OPERACIONES DE TIEMPO
      var parametroOperacioniempo_aux = {};
      for (var i in resp.data) {
        parametroOperacioniempo_aux[resp.data[i]['operacionid']] = resp.data[i];
      }

      //Se asigna un dato vacio como cabecera del array
      this.statesOperacion.push({ 'operacionid': '' });
      //Se recorre nuevamente el array con la clave del identificador de la operacion y se eliminan los duplicados
      for (i in parametroOperacioniempo_aux) {
        this.statesOperacion.push({
          'itemequipoid': parametroOperacioniempo_aux[i].operacionid,
          'nombre': parametroOperacioniempo_aux[i].operacion,
          'infooperacion': parametroOperacioniempo_aux[i].operacionid + ' => ' + parametroOperacioniempo_aux[i].operacion
        });
      }
      if (operaionid) {
        this.statesOperacion[0] = operaionid + ' => ' + operacion;
      } else {
        this.statesOperacion[0] = '';
      }
    });
  }

  /**
   * Permite obtener los equipos
   * JMM-2018-11-14
   */
  obtenerEquipos(terceroid, sucursal) {
    let sucursalid = sucursal ? sucursal.sucursalid : null;
    if (terceroid && sucursalid == null) {
      this.obtenerEquiposTercero(terceroid);
    } else if (sucursalid && terceroid == null) {
      this.getEquipoTerceroSucursal(sucursalid);
    }
  }// .obtenerEquipos(terceroid, sucursal)

  /**
   * Obtener listado de equipos por sucursal de un tercero
   * JMM-2018-11-08
   */
  getEquipoTerceroSucursal(sucursalid) {
    //Validacion para limpiar el campo del equipo
    if (sucursalid) {
      this.nuevaprogramacion.equipoterceroid = '';
    }
    this._equipoTercero.listEquipoTerceroPorTerceroSucursal(sucursalid).subscribe((resp) => {
      if (resp.data.length > 0) {
        //DATALIST
        this.statesEquipoCrear = [];
        var parametroEquipo_aux = {};
        for (var i in resp.data) {
          parametroEquipo_aux[resp.data[i]['equipoid']] = resp.data[i];
        }
        //Se asigna un dato vacio como cabecera del array
        this.statesEquipoCrear.push({ 'equipoterceroid': '' });
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroEquipo_aux) {
          this.statesEquipoCrear.push({
            'itemequipoid': parametroEquipo_aux[i].itemequipoid,
            'equipoterceroid': parametroEquipo_aux[i].equipoterceroid,
            'nombre': parametroEquipo_aux[i].nombreequipo,
            'infoequipo': parametroEquipo_aux[i].equipoterceroid + ' => ' + parametroEquipo_aux[i].nombreequipo + ' - ' + parametroEquipo_aux[i].modelo + ' Serial=>' + (parametroEquipo_aux[i].serial != null ? parametroEquipo_aux[i].serial : '')
          });
        }
      }
      else {
        this.sindatos = 'No hay datos.';
      }
    });
  }// .getEquipoTerceroSucursal()

  /**
   * Funciones Datalist para seleccionar los registros
   * JMM-2018-11-08
   */
  onSelectCliente(event: TypeaheadMatch): void { this.selectedOptionCliente = event.item.terceroid; }
  onSelectSucursal(event: TypeaheadMatch): void { this.selectedOptionSucursal = event.item; }
  onSelectEquipo(event: TypeaheadMatch): void {
    this.selectedOptionEquipo = event.item;
    this.operacionesTiempo(event.item.itemequipoid, null, null);
  }
  onSelectOperacion(event: TypeaheadMatch): void { this.nuevaprogramacion.operacionid = event.item.operacionid; }

  onSelectComponente(event: TypeaheadMatch): void {
    this.selectedOptionComponente = event.item.itemcomponenteid;
  }

  onSelectSubComponente(event: TypeaheadMatch): void {
    this.registropqr.componenteequipoid = '';
    this.GetComponentesEquipo(this.registropqr.itemequipoid, event.item.itemcomponenteid);
  }

  typeaheadNoResultsCliente(event: boolean): void { this.noResultCliente = event; }
  typeaheadNoResultsSucursal(event: boolean): void { this.noResultSucursal = event; }
  typeaheadNoResultsEquipo(event: boolean): void { this.noResultEquipo = event; }
  typeaheadNoResultsOperacion(event: boolean): void { this.noResultOperacion = event; }
  typeaheadNoResultsComponente(event: boolean): void { this.noResultComponente = event; }
  typeaheadNoResultsSubComponente(event: boolean): void { this.noResultSubComponente = event; }

  /**
   * Permite escoger el tipo de mantenimiento
   * JMM-2018-11-07
   */
  tipoMantenimiento() {
    if ($("#tipomantenimiento_agenda").val() == '0') {
      this.mostrarBotonesAgenda = false;
      this.mostrarasignar = false;
    }
    if ($("#tipomantenimiento_agenda").val() == '1') {
      this.mostrarBotonesAgenda = true;
    }
  }// .tipoMantenimiento()

  /**
   * Permite enviar la petición para guardar los datos
   * JMM-2018-11-07
   */
  submitAgendamiento() {
    //Arreglo de datos dinamicos
    let arregloDatosTecnicos1 = new Array;

    //Ciclo para recorrer los campos dinamicos asignados en el formulario
    for (let i in this.arrayAgregarTecnicosAgenda) {
      if (this.arrayAgregarTecnicosAgenda[i] != undefined) {
        //Se realiza un split para sacar los identificadores:
        let tecnicoid_aux = this.arrayAgregarTecnicosAgenda[i] ? this.arrayAgregarTecnicosAgenda[i].split("-") : '';
        let tecnicoid = tecnicoid_aux[0] ? tecnicoid_aux[0].trim() : '';
        let objetoDatosTecnicos = {
          'tecnicoid': tecnicoid
        };
        arregloDatosTecnicos1.push(objetoDatosTecnicos);
      }
    }// .for

    for (let j in this.TecnicoList) {
      if (this.TecnicoList[j] != undefined) {
        let objetoDatosTecnicos = {
          'tecnicoid': this.TecnicoList[j].tecnicoid
        };
        arregloDatosTecnicos1.push(objetoDatosTecnicos);
      }
    }// .for

    this.formNuevaprogramacion.value.tecnicoagendamiento = arregloDatosTecnicos1;
    let operacionid_aux = this.formNuevaprogramacion.value.operacionid ? this.formNuevaprogramacion.value.operacionid.split("=>") : '';
    this.formNuevaprogramacion.value.operacionid = operacionid_aux[0] ? operacionid_aux[0].trim() : '';
    this.formNuevaprogramacion.value.operacionid != '' ? this.formNuevaprogramacion.value.operacionid : (this.formNuevaprogramacion.value.operacionid = '');
    //Se realiza un split para sacar los identificadores:
    let terceroid_aux = this.formNuevaprogramacion.value.terceroid ? this.formNuevaprogramacion.value.terceroid.split("=>") : '';
    this.formNuevaprogramacion.value.terceroid = terceroid_aux[0] ? terceroid_aux[0].trim() : '';
    let sucursalid_aux = this.formNuevaprogramacion.value.sucursalid ? this.formNuevaprogramacion.value.sucursalid.split("=>") : '';
    this.formNuevaprogramacion.value.sucursalid = sucursalid_aux[0] ? sucursalid_aux[0].trim() : '';
    let equipoterceroid_aux = this.formNuevaprogramacion.value.equipoterceroid ? this.formNuevaprogramacion.value.equipoterceroid.split("=>") : '';
    this.formNuevaprogramacion.value.equipoterceroid = equipoterceroid_aux[0] ? equipoterceroid_aux[0].trim() : '';
    //Si validacion erronea del formulario muestra mensaje
    if (!this.formNuevaprogramacion.valid) {
      this.disabledBtnGuardar = false;
      this._valid.touched(this.formNuevaprogramacion);
    } else if (this.formNuevaprogramacion.value.tecnicoagendamiento == '') {
      this.disabledBtnGuardar = false;
      this.toastr.error('Debe seleccionar al menos un técnico de la lista', 'Error', { timeOut: 3000 });
    } else {
      this.disabledBtnGuardar = true;
      //Validaciones para modificar o crear el registro
      if (this.formNuevaprogramacion.value.pqrid > 0) {
        this.enviarModificarAgendamiento();
      } else {
        this.enviarCrearAgendamiento();
      }
    }
  }// .submit()

  /**
   * Permite enviar la petición a un servicio para crear el registro
   * JMM-2018-11-08
   */
  enviarCrearAgendamiento() {
    let agendamiento = {
      //AGENDEAMIENTO
      'estado': this.formNuevaprogramacion.value.estado,
      'clienteid': this.formNuevaprogramacion.value.terceroid,
      'sucursalid': this.formNuevaprogramacion.value.sucursalid,
      'coordinadorid': this.formNuevaprogramacion.value.coordinadorid,
      //HEADPQR
      'ticket': '',
      'terceroid': this.formNuevaprogramacion.value.terceroid,
      'equipoterceroid': this.formNuevaprogramacion.value.equipoterceroid,
      'asunto': this.formNuevaprogramacion.value.asunto,
      'descripcion': this.formNuevaprogramacion.value.descripcion,
      'tipopqrid': this.formNuevaprogramacion.value.tipopqrid,
      'tiposervicioid': this.formNuevaprogramacion.value.tiposervicioid,
      'usuario_creo': this.getUsuarioId,
      'prioridadid': this.formNuevaprogramacion.value.prioridadid,
      //FECHAAGENDA
      'fecha': this.formNuevaprogramacion.value.fecha,
      'horainicial': $('#horainicial').val(),
      'horafinal': $('#horafinal').val(),
      'fechafinal': this.formNuevaprogramacion.value.fechafinal,
      //AGENDAPQR
      'agendamientoid': '',
      'pqrid': this.formNuevaprogramacion.value.pqrid,
      //ALERTAPQR
      'asignado_a': this.formNuevaprogramacion.value.coordinadorid,
      'tipo': '1',
      //DETALLEPQR
      'estadopqrid': this.formNuevaprogramacion.value.estadopqrid,
      'estado_actualizado': 1,
      //TECNICOASIGNADOPQR
      'arraytecnicoid': this.formNuevaprogramacion.value.tecnicoagendamiento,
      'operacioid': this.formNuevaprogramacion.value.operacioid,
    }

    //GUARDA DATOS DE LA PQR
    this._agendamiento.setAgendamiento(agendamiento).subscribe((resp) => {
      if (resp.error) {
        this.disabledBtnGuardar = false;
        this.toastr.error(resp.data.message, 'Error', { timeOut: 3000 });
      } else {
        this.disabledBtnGuardar = false;
        this.toastr.success('Datos guardados exitosamente', '', { timeOut: 3000 });
        this.modalRef.hide();
        this.router.navigate(['main/enrutamientos/enrutamientopqr/' + this.formNuevaprogramacion.value.pqrid], { replaceUrl: true });
      }
    });
  }// enviarCrearAgendamiento()


  /**
   * Permite obtener la dependencia a la que pertenece un coordinador
   * JMM-2019-07-16
   */
  obtenerDependenciaCoordinador() {
    for (let i in this.coordinadores) {
      if (this.formNuevaprogramacion.value.coordinadorid == this.coordinadores[i].cedula) {
        this.nuevaprogramacion.dependenciaid = this.coordinadores[i].dependenciaid != ''
          && this.coordinadores[i].dependenciaid != 'null'
          && this.coordinadores[i].dependenciaid != null
          ? this.coordinadores[i].dependenciaid : '';
      }
    }
  }

  /**
   * Permite enviar la petición a un servicio para modificar el registro
   * JMM-2018-11-13
   */
  enviarModificarAgendamiento() {
    var selected = [];
    $(".checkboxAgendamiento").each(function () {
      if ($(this).is(":checked")) {
        selected.push({
          'actividadid': $(this).val(),
          'pqrid': '',
          'esactividadpqr': '1',
        });
      } else {
        selected.push({
          'actividadid': $(this).val(),
          'pqrid': '',
          'esactividadpqr': '0',
        });
      }
    }
    );

    this.formNuevaprogramacion.value.actividadid = selected;
    let agendamiento = {
      //AGENDEAMIENTO
      'estado': this.formNuevaprogramacion.value.estado,
      'clienteid': this.formNuevaprogramacion.value.terceroid,
      'sucursalid': this.formNuevaprogramacion.value.sucursalid,
      'coordinadorid': this.formNuevaprogramacion.value.coordinadorid,
      'colorhexadecimal': this.formNuevaprogramacion.value.colorhexadecimal,
      'dependenciaid': this.nuevaprogramacion.dependenciaid,
      //HEADPQR
      'ticket': this.formNuevaprogramacion.value.ticket,
      'terceroid': this.formNuevaprogramacion.value.terceroid,
      'equipoterceroid': this.formNuevaprogramacion.value.equipoterceroid,
      'asunto': this.formNuevaprogramacion.value.asunto,
      'descripcion': this.formNuevaprogramacion.value.descripcion,
      'tipopqrid': this.formNuevaprogramacion.value.tipopqrid,
      'tiposervicioid': this.formNuevaprogramacion.value.tiposervicioid,
      'usuario_creo': this.getUsuarioId,
      'prioridadid': this.formNuevaprogramacion.value.prioridadid,
      //FECHAAGENDA
      'fecha': this.formNuevaprogramacion.value.fecha,
      'horainicial': $('#horainicial').val(),
      'horafinal': $('#horafinal').val(),
      'fechafinal': this.formNuevaprogramacion.value.fechafinal,
      //AGENDAPQR
      'fechaagendaid': this.formNuevaprogramacion.value.fechaagendaid,
      'agendamientoid': this.formNuevaprogramacion.value.agendamientoid ? this.formNuevaprogramacion.value.agendamientoid : null,
      'pqrid': this.formNuevaprogramacion.value.pqrid,
      //ALERTAPQR
      'alertapqrid': this.formNuevaprogramacion.value.alertapqrid,
      'asignado_a': this.formNuevaprogramacion.value.coordinadorid,
      'tipo': '1',
      //DETALLEPQR
      'estadopqrid': this.formNuevaprogramacion.value.estadopqrid,
      'detallepqrid': this.formNuevaprogramacion.value.detallepqrid,
      'estado_actualizado': 1,
      //TECNICOASIGNADOPQR
      'arraytecnicoid': this.formNuevaprogramacion.value.tecnicoagendamiento,
      'actividadid': this.formNuevaprogramacion.value.actividadid,
      'operacionid': this.formNuevaprogramacion.value.operacionid,

      //Datos si tiene conexión en linea
      'incconelineaconta': this.incconelineaconta,
      'incconelineainven': this.incconelineainven,
      'servidorbdconta': this.servidorbdconta,
      'basedatosconta': this.basedatosconta,
      'usuarioconta': this.usuarioconta,
      'claveconta': this.claveconta,
      'servidorbdinven': this.servidorbdinven,
      'basedatosinven': this.basedatosinven,
      'usuarioinven': this.usuarioinven,
      'claveinven': this.claveinven,
      'tipoinventario': this.tipoinventario
    }

    //GUARDA DATOS DE LA PQR
    this._agendamiento.editAgendamiento(agendamiento).subscribe((resp) => {
      if (resp.data == 'I') {
        this.toastr.error('Ya existe un registro con el mismo Número de ticket ó el campo esta vacio', 'Error', { timeOut: 3000 });
        this.disabledBtnGuardar = false;
      }
      else if (resp.error) {
        this.disabledBtnGuardar = false;
        this.toastr.error('Error al actualizar', 'Error', { timeOut: 3000 });
      }
      else {
        this.disabledBtnGuardar = false;
        this.toastr.success('Datos actualizados exitosamente', '', { timeOut: 3000 });
        this.modalRef.hide();
        this.router.navigate(['main/enrutamientos/enrutamientopqr/' + this.formNuevaprogramacion.value.pqrid], { replaceUrl: true });
      }
    });
  }// enviarModificarAgendamiento()


  /**
   * Permite obtener los permisos y perfiles de usuario
   * JMM-2018-12-26
   */
  getPermisos(id_pqr) {
    this._perfiles.getPermisosUsuariosFull().subscribe((resp) => {
      if (resp.data) {
        this.listpermisos = resp.data;
        this.obtenerPqrs(id_pqr);
        this.mostrarpreloaderpri = 0;
      } else {
        this.mostrarpreloaderpri = 1;
      }
      this.obtenerTipoServicioAgendamiento();
      this.obtenerUsuariosTipo('TE');
      this.obtenerUsuariosTipo('CO');
    });
  }

  /**
   * Función para optener el servicio por mantenimiento preventivo
   * JMM-2019-01-14
   */
  obtenerTipoServicioAgendamiento() {
    this._tiposervicio.getTipoServicio().subscribe((resp) => {
      if (this.agendartodotiposervicio == '1') {
        this.tiposerviciosagendamiento = resp.data;
      } else {
        this._tiposervicio.obtener_serviciopreventivo().subscribe((resp) => {
          if (resp.data) {
            this.tiposerviciosagendamiento = resp.data;
          }
        });
      }
    });
  }// .obtenerTipoServicio()

  ActiviarBtnGuardar(h) {
    $("#ActiviarBtnGuardar_" + h).addClass("hide");
    $(".privado_" + h).removeClass('hide');
    $("#notadetallpqr_" + h).removeAttr('disabled');
    $("#notadetallpqr_" + h).css('background', 'white');
    $("#editarNotadetallepqr_" + h).removeClass('hide');
  }

  /**
   * Permite enviar la petición para Editar el una nota de la incidencia
   * CESAR AUGUSTO ARIAS-2019-10-10
   */
  editarNotadetallepqr(id, h) {
    var privado = '';
    $("#privado_" + h).each(function () {
      if ($(this).is(":checked")) {
        privado = '1';
      } else {
        privado = '0';
      }
    }
    );

    let data = {
      'detalle': $("#notadetallpqr_" + h).val(),
      'pqrid': this.registropqr.pqrid,
      'privado': privado
    };
    this._notadetallepqr.updateNotadetallepqr(data, id).subscribe((resp) => {
      if (resp.data.errorInfo) {
        this.toastr.error(resp.data.errorInfo[2], 'Error', { timeOut: 3000 });
      } else if (resp.data == 1) {
        this.toastr.warning(resp.message, '', { timeOut: 3000 });
        $("#editarNotadetallepqr_" + h).addClass("hide");
        $("#ActiviarBtnGuardar_" + h).removeClass('hide');
        this.obtenerNotasDetallePqr(this.registropqr.pqrid);
      } else {
        this.toastr.success(resp.message, '', { timeOut: 3000 });
        $("#editarNotadetallepqr_" + h).addClass("hide");
        $("#ActiviarBtnGuardar_" + h).removeClass('hide');
        this.obtenerNotasDetallePqr(this.registropqr.pqrid);
      }
    });
  }

  /**
   * Permite enviar la petición para eliminar el una nota de la incidencia
   * CESAR AUGUSTO ARIAS-2019-10-10
   */
  eliminarNotadetallepqr(id, h) {
    swal({
      title: 'Esta seguro de eliminar el registro?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this._notadetallepqr.destroyNotasPqr(id).subscribe((resp) => {
          if (resp.error) {
            this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
          } else {
            // Rastreo
            let opcionEnvio = 'Modifica Tratamiento Incidencia :' + this.registropqr.pqrid + '  Elimina Nota: ' + $("#notadetallpqr_" + h).val() + ': con el id: ' + id;
            this._rastreo.setRastreo(opcionEnvio, 'Tratamiento de la Incidencia').subscribe((resp) => {
            }); // fin rastreos

            this.obtenerNotasDetallePqr(this.registropqr.pqrid);
            this.toastr.success(resp.message, '', { timeOut: 3000 });
          }
        })
      } // .if (result.value)
    });
  }

  /**
   * Viculos a otros modulos
   * CESAR ARIAS-2019-12-17
   */
  vincularModulo(param) {
    this.router.navigate(['main/enrutamientos/enrutamientofichastecnicas/' + this.registropqr.fichatecnica + '/' + this.registropqr.itemequipoid + '/' + this.registropqr.equipoid], { replaceUrl: true });
  }

  /**
   * Permite abrir un modal para seleccionar la hora
   * JMM-2019-02-21
   */
  abrirModalHoraLimite(eventoclic, param) {
    if (param == 'divhoralimite') {
      this.eventoclic = (eventoclic == 1) ? 0 : 1;
      if (this.eventoclic == 0) {
        $('#divhoralimite').show();
      } else {
        $('#divhoralimite').hide();
      }
    }
  }// .abrirModalHora(template:any)

  /**
  * Obtener listado de equipos por sucursal de un tercero
  * JMM-2018-11-08
  */
  GetComponentesEquipo(itemequipoid, itemcomponenteid) {
    //Validacion para limpiar el campo del equipo
    if (itemequipoid) {
      this.nuevaprogramacion.equipoterceroid = '';
    }

    this._pqr.GetComponentesEquipo(itemequipoid).subscribe((resp) => {
      if (resp.data.length > 0) {
        //DATALIST
        this.statesComponentes = [];
        var parametroEquipo_aux = {};
        for (var i in resp.data) {
          parametroEquipo_aux[resp.data[i]['itemcomponenteid']] = resp.data[i];
        }
        //Se asigna un dato vacio como cabecera del array
        this.statesComponentes.push({ 'itemcomponenteid': '' });
        //Se recorre nuevamente el array con la clave del identificador de la sucursal y se eliminan los duplicados
        for (i in parametroEquipo_aux) {
          this.statesComponentes.push({
            'itemcomponenteid': parametroEquipo_aux[i].itemcomponenteid,
            'componenteid': parametroEquipo_aux[i].componenteid,
            'fichatecnicaservicioid': parametroEquipo_aux[i].fichatecnicaservicioid,
            'nombre': parametroEquipo_aux[i].nombre,
            'equipoid': parametroEquipo_aux[i].equipoid,
            'serial': parametroEquipo_aux[i].serial,
            'infocomponente': parametroEquipo_aux[i].itemcomponenteid + ' => ' + parametroEquipo_aux[i].nombre + ' Serial - ' + (parametroEquipo_aux[i].serial != null ? parametroEquipo_aux[i].serial : '')
          });
        }

        let self: any = this;
        setTimeout(function () {
          if (itemcomponenteid) {
            // self.registropqr.itemcomponenteid = itemcomponenteid + ' => '+ nombre + ' Serial - '+serialcomponente;
            $('#itemcomponenteid').val(itemcomponenteid).trigger('chosen:updated');
            let validar: any = self.statesComponentes.filter(function (car) {
              return car.itemcomponenteid == itemcomponenteid;
            });
            self.GetSubComponentesEquipo(validar[0].equipoid, validar[0].componenteid, validar[0].fichatecnicaservicioid);
          } else {
            self.registropqr.itemcomponenteid = '';
            $('#itemcomponenteid').val('').trigger('chosen:updated');
          }
        }, 0);
      } else {
        this.sindatos = 'No hay datos.';
      }
    });
  }// .GetComponentesEquipo()

  GetSubComponentesEquipo(equipoid, componenteid, fichatecnicaservicioid) {
    let self = this;
    this._pqr.GetSubComponentesEquipo(equipoid, componenteid, fichatecnicaservicioid).subscribe((resp) => {
      this.statesSubComponentes = [];
      for (let i in resp.data) {
        this.statesSubComponentes.push({
          'componenteequipoid': resp.data[i].componenteequipoid,
          'componenteid': resp.data[i].componenteid,
          'fichatecnicaservicioid': resp.data[i].observacion,
          'nombre': resp.data[i].nombre,
          'equipoid': resp.data[i].equipoid,
          'infosubcomponente': resp.data[i].componenteequipoid + ' => ' + resp.data[i].nombre
        });
      }

      setTimeout(function () {
        if (self.registropqr.componenteequipoid) {
          $('#componenteequipoid').val(self.registropqr.componenteequipoid).trigger('chosen:updated');
        } else {
          self.registropqr.componenteequipoid = '';
          $('#componenteequipoid').val('').trigger('chosen:updated');
        }
      }, 0);
    });
  }

  validarformulario() {
    $("#proveedorid").val('');
    this.tapqrArray = [];
    this.arrayAgregarTecnicos = [];
    $("#proveedorid").attr('disabled', false);
    this.obtenerNotasDetallePqr(this.registropqr.pqrid);
  }

  agregarProveesorNuevo() {
    $("#").val("");
    $('#costo').val('');
    if ($('#proveedorid').val() != "") {
      this.fototercero($('#proveedorid').val(), $('#proveedorid').val() + ' - ' + $('#proveedorid option:selected').text())
      this.validarcostoCambioProveedor();
    }
  }

  validaprioridad() {
    let self = this;
    let validar = this.tiposprioridad.filter(function (car) {
      return car.prioridadid == self.registropqr.prioridadid;
    });

    if (validar.length > 0 && validar[0].tiempo && validar[0].valorfrecuencia) {
      let tiempo = validar[0].tiempo;
      let valorfechalimite = validar[0].valorfrecuencia;
      let fechalimite = '';
      let fechainicialLimite = this.registropqr.fechapqr;

      //validación para la fecha limete automatica segun la prioridad
      switch (tiempo) {
        case '001': //hora
          this._tratamientopqr.fechaLimiteTratamiento(this.registropqr.fechapqr, this.registropqr.prioridadid).subscribe((resp) => {
            fechalimite = resp.data;
          });
          fechalimite = moment(fechainicialLimite).add(valorfechalimite, 'hours').format("YYYY-MM-DD HH:mm:ss"); //hora
          break;
        case '002': //dia
          fechalimite = moment(fechainicialLimite).add(valorfechalimite, 'day').format("YYYY-MM-DD HH:mm:ss");//dia
          break;
        case '003': //semana
          fechalimite = moment(fechainicialLimite).add(valorfechalimite, 'week').format("YYYY-MM-DD HH:mm:ss");//semana
          break;
        case '004': //mes
          fechalimite = moment(fechainicialLimite).add(valorfechalimite, 'month').format("YYYY-MM-DD HH:mm:ss");//mes
          break;
        case '005': //año
          fechalimite = moment(fechainicialLimite).add(valorfechalimite, 'year').format("YYYY-MM-DD HH:mm:ss");//año
          break;
      }

      setTimeout(function () {
        self.registropqr.colorfechalimite = '#fff';
        self.registropqr.fechalimite = moment(fechalimite).format("YYYY-MM-DD");
        self.registropqr.horalimite = moment(fechalimite).format("HH:mm:ss");
      }, 1000);
    } else {
      this.registropqr.fechalimite = null;
      this.registropqr.horalimite = null;
    }
  }

  relacionarInc() {
    this.arrayAsignacion = $('.pqrarelacionar').val();
    if (this.arrayAsignacion.length > 0) {
      let data = {
        pqrid: this.registropqr.pqrid,
        arraypqr: this.arrayAsignacion
      }
      this._tratamientopqr.submitRelacionarInc(data).subscribe((resp) => {
        if (resp.error) {
          this.toastr.warning(resp.message, 'Alerta', { timeOut: 3000 });
          this.disabled = false;
        } else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          $('.pqrarelacionar').val('').trigger('chosen:updated');
          this.getIncAsignada();
        }
      });
    } else {
      this.toastr.warning('No hay datos para guardar', 'Alerta', { timeOut: 3000 });
    }
  }

  /**
   * Formulario para validar los campos en la creación de registros
   * JMM-2018-11-07
   */
  formnuevaprogramacion() {
    this.formNuevaprogramacion = new FormGroup({
      'agendamientoid': new FormControl(this.nuevaprogramacion.agendamientoid),
      'fechaagendaid': new FormControl(this.nuevaprogramacion.fechaagendaid),
      'detallepqrid': new FormControl(this.nuevaprogramacion.detallepqrid),
      'alertapqrid': new FormControl(this.nuevaprogramacion.alertapqrid),
      'tipomantenimientoid': new FormControl(this.nuevaprogramacion.tipomantenimientoid),
      'fecha': new FormControl(this.nuevaprogramacion.fecha, [Validators.required]),
      'horainicial': new FormControl(this.nuevaprogramacion.horainicial, [Validators.required]),
      'horafinal': new FormControl(this.nuevaprogramacion.horafinal, [Validators.required]),
      'pqrid': new FormControl(this.nuevaprogramacion.pqrid),
      'ticket': new FormControl(this.nuevaprogramacion.ticket),
      'estado': new FormControl(this.nuevaprogramacion.estado, [Validators.required]),
      'terceroid': new FormControl(this.nuevaprogramacion.terceroid, [Validators.required]),
      'sucursalid': new FormControl(this.nuevaprogramacion.sucursalid),
      'equipoterceroid': new FormControl(this.nuevaprogramacion.equipoterceroid, [Validators.required]),
      'asunto': new FormControl(this.nuevaprogramacion.asunto, [Validators.required]),
      'tiposervicioid': new FormControl(this.nuevaprogramacion.tiposervicioid, [Validators.required]),
      'estadopqrid': new FormControl(this.nuevaprogramacion.estadopqrid, [Validators.required]),
      'tipopqrid': new FormControl(this.nuevaprogramacion.tipopqrid, [Validators.required]),
      'coordinadorid': new FormControl(this.nuevaprogramacion.coordinadorid, [Validators.required]),
      'descripcion': new FormControl(this.nuevaprogramacion.descripcion),
      'presupuestoplaneado': new FormControl(this.nuevaprogramacion.presupuestoplaneado),
      'tecnicoagendamiento': new FormControl(this.nuevaprogramacion.tecnicoagendamiento),
      'fechafinal': new FormControl(this.nuevaprogramacion.fechafinal),
      'prioridadid': new FormControl(this.nuevaprogramacion.prioridadid),
      'tiempo': new FormControl(this.nuevaprogramacion.tiempo),
      'valorfrecuencia': new FormControl(this.nuevaprogramacion.valorfrecuencia),
      'colorhexadecimal': new FormControl(this.nuevaprogramacion.colorhexadecimal),
      'tipoactividadid': new FormControl(this.nuevaprogramacion.tipoactividadid),
      'validadoperaciontiempo': new FormControl(this.nuevaprogramacion.validadoperaciontiempo),
      'itemcomponenteid': new FormControl(this.nuevaprogramacion.itemcomponenteid),
      'otrocoordinadorid': new FormControl(this.nuevaprogramacion.otrocoordinadorid),
      'operacionid': new FormControl(this.nuevaprogramacion.operacionid),
      'esproveedor': new FormControl(this.nuevaprogramacion.esproveedor),
    });
  }

  abreModalListaChequeo() {
    this.muestraModalListaChequeo = !this.muestraModalListaChequeo;
  }

  cerrarModalListachequeo(evento) {
    $('#incidenciaListaChequeoModal').modal('hide');
    this.muestraModalListaChequeo = !this.muestraModalListaChequeo;
    this.reloadTablaListaChequeo = !this.reloadTablaListaChequeo;
  }

  relogueaPagina() {
    $('#incidenciaListaChequeoModal').modal('hide');
    this.router.navigate(['main/enrutamientos/enrutamientopqr/', this.pqrid]);
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/pqr/tratamiento-pqr/tratamiento-pqr.component.ts